import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Kampagnen',
    Label: 'Neue erstellen'
  },

  [CampaignListTableKey]: {
    All: 'Alle',
    Draft: 'Entwurf',
    Pending: 'Ausstehend',
    Scheduled: 'Geplant',
    Active: 'Aktiv',
    Ended: 'Beendet',
    Inactive: 'Inaktiv',
    SearchPlaceholder: 'Kampagne nach Namen, ID oder internen Notizen suchen',
    FilterBy: 'Filtern nach',

    // Game Types
    TapWin: 'Tippen & Gewinnen',
    CollectWin: 'Sammeln & Gewinnen',
    ShakeTheTree: 'Schüttel den Baum',
    HitThePinata: 'Triff die Piñata',
    SpinTheWheel: 'Dreh das Glücksrad',
    Plinko: 'Plinko',
    MysteryBox: 'Überraschungsbox',
    ScratchCard: 'Rubbellos',
    BubblePop: 'Blasenblasen',

    OnDeactivateErrorMessage: 'Fehler beim Deaktivieren der Kampagne',
    OnApproveErrorMessage: 'Fehler beim Genehmigen der Kampagne',
    OnMoveRowErrorMessage: 'Fehler beim Sortieren der Kampagne.',

    Approve: 'Genehmigen',
    Review: 'Überprüfen',
    Edit: 'Bearbeiten',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    Duplicate: 'Duplizieren',
    UploadTries: 'Versuche hochladen',
    MoveToTop: 'Nach oben verschieben',
    ApproveCampaign: 'Kampagne genehmigen',

    Name: 'Name',
    Type: 'Typ',
    Status: 'Status',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    Request: 'Anfrage',
    Comments: 'Kommentare',
    Actions: 'Aktionen',
    AllGames: 'Alle Spiele',
    ApproveRequests: 'Anfragen genehmigen',
    CampaignTypeNotAllowedForApproval:
      'Dieser Kampagnentyp ist nicht aktiviert. Bitte wenden Sie sich für weitere Unterstützung an Perx.',
    InternalNotes: 'Interne Notizen',
    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Anfragen wurden genehmigt',
      SuccessMessage: 'Kampagnen genehmigt',
      ErrorMessage: 'Fehler beim Genehmigen der Kampagnen.',
      Title: 'Mehrere Anfragen genehmigen?',
      OkText: 'Ausgewählte genehmigen',
      CancelText: 'Abbrechen',
      DescriptionLineOne:
        'Sind Sie sicher, dass Sie alle ausgewählten Anfragen genehmigen möchten?',
      DescriptionLineTwo:
        'Bitte überprüfen Sie die Details vor der Genehmigung, da diese Aktion nicht rückgängig gemacht werden kann.',
      ErrorApprovingRewards: 'Fehler beim Genehmigen der Belohnungen.'
    },

    ApproveMessageModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Kampagne.',
      Title: 'Kampagne genehmigen?',
      OkText: 'Genehmigen',
      DescriptionLineOne: 'Sind Sie sicher, dass Sie diese Kampagne genehmigen möchten?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.'
    },

    CampaignType: {
      AllCampaigns: 'Alle Kampagnen',
      InstantReward: 'Sofortbelohnung',
      Stamp: 'Stempel',
      Referral: 'Referral',
      Game: 'Spiel',
      Reward: 'Belohnung',
      Quiz: 'Quiz',
      Survey: 'Umfrage',
      Quest: 'Quest',
      Progress: 'Fortschritt',
      Raffle: 'Gewinnspiel',
      MultipleRuleCampaign: 'Mehrfachregelkampagne'
    }
  },

  [CampaignCreatePageKey]: {
    CreatingACampaign: 'Kampagne wird erstellt',
    CampaignCreated: 'Kampagne erstellt',
    CampaignSubmittedForApproval: 'Kampagne wurde zur Genehmigung eingereicht',
    FailedToCreateCampaign: 'Kampagne konnte nicht erstellt werden',
    DeactivatingCampaign: 'Kampagne wird deaktiviert...',
    CampaignDeactivationRequestSubmittedForApproval:
      'Deaktivierungsanfrage für die Kampagne wurde zur Genehmigung eingereicht!',
    DeactivatingSuccess: 'Deaktivierung erfolgreich...',
    FailedToDeactivate: 'Deaktivierung fehlgeschlagen!',

    ActivatingCampaign: 'Kampagne wird aktiviert...',
    CampaignActivationRequestSubmittedForApproval:
      'Aktivierungsanfrage für die Kampagne wurde zur Genehmigung eingereicht!',
    ActivatingSuccess: 'Aktivierung erfolgreich...',
    FailedToActivate: 'Aktivierung fehlgeschlagen!',
    UpdatingCampaign: 'Kampagne wird aktualisiert',
    CampaignUpdateRequestSubmittedForApproval: 'Kampagne wurde zur Genehmigung eingereicht!',
    FailedToUpdate: 'Fehler beim Aktualisieren der Kampagne!',

    FailedToLoadData: 'Fehler beim Laden der Daten!',
    FailedToOrderCampaign: 'Fehler beim Sortieren der Kampagne!',

    DuplicatingCampaign: 'Kampagne wird dupliziert...',
    OnSubmitErrorMessage: 'Keine Änderungen erkannt',

    RequiredErrorMessage: 'Kampagnenname ist erforderlich',
    UploadedImagesShouldBeSetAsASection:
      'Hochgeladene Bilder müssen als Abschnitt festgelegt werden',
    PromoteUntilMustBeAfterStartDate: 'Das Promotionsdatum muss nach dem Startdatum liegen',
    PromoteUntilMustBeBeforeEndDate: 'Das Promotionsdatum muss vor dem Enddatum liegen',
    PromoteUntilMustBeBetweenStartAndEndDate:
      'Das Promotionsdatum muss zwischen Start- und Enddatum liegen',
    PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer aus',
    PleaseAddAtLeast2Outcomes: 'Bitte fügen Sie mindestens 2 Ergebnisse hinzu',
    PrizeSetMustIncludeAtLeastOnePrizeForSlotNumber:
      'Das Preisset muss mindestens einen Preis für Slot Nummer {{position}} enthalten',
    PleaseAddAPrizeTitleForSlotNumber:
      'Bitte fügen Sie einen Preis-Titel für Slot Nummer {{position}} hinzu',
    PleaseAddAtLeast2OutcomesForSlotNumber:
      'Bitte fügen Sie mindestens 2 Ergebnisse für Slot Nummer {{position}} hinzu',
    PrizeSetMustIncludeAtLeastOnePrize: 'Das Preisset muss mindestens einen Preis enthalten',
    RandomOutcomeSetMustIncludeAtLeastOneOutcome:
      'Das zufällige Ergebnisset {{index}} muss mindestens ein Ergebnis enthalten',
    RandomOutcomeSetMustIncludeAtLeastTwoOutcomes:
      'Das zufällige Ergebnisset {{index}} muss mindestens 2 Ergebnisse enthalten',
    TotalProbabilityOfRandomOutcomeSet:
      'Die Gesamtwahrscheinlichkeit des zufälligen Ergebnissesets {{index}} sollte 100% betragen',
    HeadlineHasToBeSet: 'Überschrift muss festgelegt werden',
    SubHeadlineHasToBeSet: 'Unterüberschrift muss festgelegt werden',
    RewardMustBePlacedOnAtLeastOneWedge:
      'Belohnung muss auf mindestens einem Feld platziert werden',
    AtLeast1WedgeMustRemainEmptyIfNoOutcomeIsSelected:
      'Mindestens ein Feld muss leer bleiben, wenn "Kein Ergebnis" ausgewählt ist',
    EachOutcomeMustHaveADuplicateScore:
      'Jedes Ergebnis muss eine eindeutige Punktzahl haben. Duplikate gefunden: {{duplicateList}}',
    ScoreMustBeGraterThanZero: 'Punktzahl muss größer als 0 sein.',
    AtLeastOneBubbleMustBeConfigured: 'Mindestens eine Blase muss konfiguriert werden',
    ColorHasToBeSet: 'Farbe muss festgelegt werden',
    PointHasToBeSet: 'Punkt muss festgelegt werden',
    SVGCodeIsRequired:
      'SVG-Code ist erforderlich, wenn ein benutzerdefiniertes Bild ausgewählt ist.',
    TargetTypeMustBeSelected: 'Zieltyp muss ausgewählt werden.',
    BubbleSpawnRateMustBeSelected: 'Blasen-Spawnrate muss ausgewählt werden.',
    MaxBubblesMustBePositive: 'Max. Blasen muss eine positive Zahl sein.',
    SpawnIntervalMustBeAtLeast100ms: 'Spawn-Intervall muss mindestens 100 Millisekunden betragen.',
    BubbleLifetimeMustBeAtLeast500ms:
      'Blasen-Lebensdauer muss mindestens 500 Millisekunden betragen.',
    BubblesPerSpawnMustBePositive: 'Blasen pro Spawn muss eine positive Zahl sein.',
    BubblesPerSpawnMustNotExceedMaxBubbles:
      'Blasen pro Spawn darf die maximale Blasenanzahl nicht überschreiten.',
    GameDurationMinimum10Seconds: 'Spieldauer muss mindestens 10 Sekunden betragen.',
    MaximumOf5BubblesCanBeMarkedAsBonus: 'Maximal 5 Blasen können als Bonus markiert werden.',
    BonusImageOccurrenceMustBeBetween1And6: 'Bonus-Bild-Vorkommen muss zwischen 1 und 6 liegen.',
    YouNeedToAddAtLeastOneQuestionToThe:
      'Sie müssen mindestens eine Frage zum {{campaignType}} hinzufügen.',
    EnglishTextForTheQuestionIsRequired:
      'Englischer Text für die Frage #{{questionNumber}} ist erforderlich',
    EnglishTextForTheChoiceIsRequired:
      'Englischer Text für die Auswahl #{{choiceNumber}} der Frage #{{questionNumber}} ist erforderlich',
    YouNeedToAddAtLeastOneTask: 'Sie müssen mindestens eine Aufgabe hinzufügen',
    YouNeedToSpecifyARuleForTheTask:
      'Sie müssen eine Regel für die Aufgabe #{{taskNumber}} angeben',
    CampaignDurationIsRequired: 'Kampagnendauer ist erforderlich',
    CampaignDurationMustBeGreaterThanZero: 'Kampagnendauer muss größer als 0 sein',
    BodyHasToBeSetForQuestDisplaySetup: 'Textkörper muss für die Quest-Anzeige festgelegt werden',
    YouNeedToSpecifyTheTeamSize: 'Sie müssen die Teamgröße angeben',
    TeamSizeMustBePositive: 'Teamgröße muss positiv sein',
    EnglishHeadlineCannotBeEmpty: 'Englische Überschrift darf nicht leer sein',
    LevelTabNameCannotBeEmpty: "'Level Tab'-Name darf nicht leer sein",
    CampaignPointsShortFormCannotBeEmpty: "'Kampagnenpunkte-Kurzform' darf nicht leer sein",
    YouNeedToSpecifyACampaignPointsForTheLevel:
      'Sie müssen Kampagnenpunkte für Level #{{levelNumber}} angeben',
    YouNeedToSpecifyAnIssuePrizeDescriptionForTheLevel:
      'Sie müssen eine "Preis ausgeben"-Beschreibung für Level #{{levelNumber}} angeben',
    LevelPointsMustBeMoreThanLevelPoints:
      'Level {{levelNumber}} Punkte müssen mehr als Level {{errorIndex}} Punkte sein!',
    YouNeedToAddAtLeast2OutcomesForTheLevel:
      'Sie müssen mindestens 2 Ergebnisse für Level #{{levelNumber}} hinzufügen',
    PrizeSetRequiresAPrizeTitleForTheLevel:
      'Das Preisset erfordert einen Preis-Titel für Level #{{levelNumber}}',
    YouNeedToAddAtLeastOneOutcomeForTheRandomizedOutcomeSet:
      'Sie müssen mindestens ein Ergebnis für das zufällige Ergebnisset {{randomOutcomeIndex}} in Level #{{levelNumber}} hinzufügen',
    TheProbabilitiesOfTheOutcomesInRandomizedOutcomeSet:
      'Die Wahrscheinlichkeiten der Ergebnisse im zufälligen Ergebnisset {{randomOutcomeIndex}} von Level #{{levelNumber}} müssen insgesamt 100% ergeben',
    EachOutcomeProbabilityInRandomizedOutcomeSetMustBeGreaterThanZero:
      'Die Wahrscheinlichkeit jedes Ergebnisses im zufälligen Ergebnisset {{randomOutcomeIndex}} von Level #{{levelNumber}} muss größer als 0% sein',
    HowToParticipateTabNameCannotBeEmpty: "'Teilnahme-Tab'-Name darf nicht leer sein",
    HowToParticipateBodyTextCannotBeEmpty: "'Teilnahme-Tab'-Text darf nicht leer sein",
    NumbersHaveToBeLessThan: 'Zahlen müssen kleiner als {{maxValue}} sein!',
    OperatingClosesTimeShouldBeGreaterThanOperatingOpensTime:
      'Die Schließzeit muss nach der Öffnungszeit liegen',
    OperatingOpensTimeShouldBeEarlierThanOperatingClosesTime:
      'Die Öffnungszeit muss vor der Schließzeit liegen',
    DaysCannotBeEmptyPleaseSelectValidDays:
      'Tage dürfen nicht leer sein. Bitte wählen Sie gültige Tage aus',
    TimesCannotBeEmptyPleaseSelectValidTimes:
      'Zeiten dürfen nicht leer sein. Bitte wählen Sie gültige Zeiten aus',
    ProbabilityMustAlwaysAddUpTo100: 'Die Wahrscheinlichkeit muss immer 100% ergeben',
    ProbabilityShouldBeGreaterThan0: 'Die Wahrscheinlichkeit muss größer als 0% sein',
    OutcomesCannotBeEmpty: 'Ergebnisse dürfen nicht leer sein.',
    EndDateCannotBeEmpty: 'Enddatum darf nicht leer sein.',
    AddAtLeastOneRule: 'Fügen Sie mindestens eine Regel hinzu',
    AddAtLeastOnePrizeSet: 'Fügen Sie mindestens ein Preisset hinzu',
    AddAtLeastOneOutcomeToThePrizeSet: 'Fügen Sie mindestens ein Ergebnis zum Preisset hinzu',
    PleaseUploadTheFile: 'Bitte laden Sie die Datei hoch',
    CampaignRequestUpdated: 'Kampagneanfrage aktualisiert',
    CampaignIsSubmittedForApproval: 'Kampagne wurde zur Genehmigung eingereicht',
    CampaignUpdated: 'Kampagne aktualisiert',
    LimitTo: 'Begrenzen auf',
    SelectTaskTypeIsRequired: 'Aufgabentyp ist erforderlich',
    StreakModeIsRequired: 'Serienmodus ist erforderlich',
    AmountSpendIsRequired: 'Ausgabebetrag ist erforderlich',
    AmountSpendMustBeGreaterThanZero: 'Ausgabebetrag muss größer als null sein',
    StreakTargetIsRequired: 'Serienziel ist erforderlich',
    StreakTargetCriteriaIsRequired: 'Kriterien für das Serienziel sind erforderlich',
    StreakDurationIsRequired: 'Seriendauer ist erforderlich',
    MilestonesAndPrizesAreRequired: 'Meilensteine und Preise sind erforderlich',
    AtLeastOneOutcomeIsRequiredForMilestonesAndPrizes:
      'Mindestens ein Ergebnis ist für Meilensteine und Preise erforderlich',
    AtLeastOneConditionIsRequired: 'Mindestens eine Bedingung ist erforderlich',
    InvalidCondition: 'Ungültige Bedingung',
    SelectTriggerFieldIsRequired: 'Triggerfeld ist erforderlich',
    OperatorFieldIsRequired: 'Operatorfeld ist erforderlich',
    ValueIsRequired: 'Wert ist erforderlich',

    Steps: {
      Back: 'Zurück',
      Cancel: 'Abbrechen',
      Next: 'Weiter',
      SaveAsDraft: 'Als Entwurf speichern',
      Publish: 'Veröffentlichen',
      Save: 'Speichern',
      Deactivate: 'Deaktivieren',
      Schedule: 'Planen',
      StreakMode: 'Serienmodus',
      TaskType: 'Aufgabentyp',
      StreakTargetAndPrizes: 'Serienziel und Preise',

      Info: 'Info',
      SelectAudience: 'Zielgruppe auswählen',
      Mechanics: 'Mechanik',
      Review: 'Überprüfung',
      DetailedTitle: {
        Info: 'Kampagnen-Info',
        SelectAudience: 'Zielgruppe auswählen',
        Mechanics: 'Mechanik',
        Review: 'Überprüfung'
      },
      ViewInsights: 'Insights ansehen',
      Edit: 'Bearbeiten',
      Loading: 'Laden'
    },

    CampaignInfo: {
      Title: 'Kampagnendetails',
      Form: {
        Name: 'Name',
        NamePlaceholder: 'Bitte geben Sie Ihren Kampagnennamen ein',
        ContentSuggestions: 'Inhaltsvorschläge',
        ShowChatGPTForm: {
          TooltipTitle:
            'Token-Limits werden täglich erneuert. Werden Sie Perx-Exklusivmitglied für unbegrenzte Tokens',
          TokensLeft: 'Token übrig'
        },
        Description: 'Beschreibung',
        TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
        RiskDisclaimer: 'Risikohinweis',
        InternalNotesNotVisibleToCustomers: 'Interne Notizen (für Kunden nicht sichtbar)',
        InternalNotesNotVisibleToCustomersPlaceholder:
          'Geben Sie optional Notizen nur für den internen Gebrauch ein. Dieser Text ist für Kunden nicht sichtbar.',
        MaxCharacters: 'Max {{count}} Zeichen.',
        CampaignDuration: 'Kampagnendauer',
        StartDate: 'Startdatum',
        EndDate: 'Enddatum',
        EarlyDisplayCampaign: 'Kampagne früher anzeigen',
        DaysBeforeStartDate: 'Tage vor dem Startdatum',
        DaysBeforeTheStartDate: 'Tage vor dem Startdatum',
        CampaignDoesNotEnd: 'Kampagne endet nicht',
        ShouldHideDurationEndDateAlertMessage: 'Gewinnspielkampagnen benötigen ein Enddatum',
        EndDateAlertMessage: 'Das Enddatum muss am oder nach dem Startdatum liegen',

        Reset: 'Zurücksetzen',
        OCBCDemo: {
          Never: 'Nie',
          Weekly: 'Wöchentlich',
          Monthly: 'Monatlich',
          Yearly: 'Jährlich'
        },

        ActiveAt: 'Aktiv ab',
        ActiveAtMessage: 'Kampagne aktiviert sich nicht vor dem Startdatum',

        Tags: 'Tags',
        Categories: 'Kategorien',
        Labels: 'Labels',
        Catalogues: 'Kataloge',
        Owner: 'Besitzer',
        PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer',

        UploadPhoto: 'Foto hochladen',
        UploadMultipleImages: 'Mehrere Bilder hochladen',
        Merchant: 'Händler',
        MerchantSelectPlaceholder: 'Bitte wählen Sie einen Händler',
        Locations: 'Standorte',
        LocationsSelectPlaceholder: 'Bitte wählen Sie Standorte',
        CustomFields: 'Benutzerdefinierte Felder',
        CustomField: 'Benutzerdefiniertes Feld',
        CustomFieldNamePlaceholder: 'Bitte geben Sie den Feldnamen ein',
        CustomFieldValuePlaceholder: 'Bitte geben Sie den Feldwert ein',
        AddCustomField: 'Benutzerdefiniertes Feld hinzufügen'
      },

      TagSelect: 'Bitte wählen Sie Ihre Tags',
      CategorySelect: 'Bitte wählen Sie Ihre Kategorien',
      LabelSelect: 'Bitte wählen Sie Ihre Labels',
      CatalogueSelect: 'Bitte wählen Sie Ihre Kataloge'
    },

    ButtonWithImageUpload: {
      Cancel: 'Abbrechen',
      InsertPhoto: 'Foto einfügen',
      UploadFile: 'Datei hochladen',
      ChooseFile: 'Datei auswählen',
      ChooseAFile: 'Datei auswählen',
      SelectPngSvgJpegGif: 'PNG, SVG, JPEG oder GIF auswählen'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Zielgruppe auswählen',
      DefaultAudience: 'Erstellen Sie eine einmalige Zielgruppe für diese Kampagne',
      ExistingAudience: 'Wählen Sie eine vorhandene Zielgruppe',
      AudienceSetup: 'Zielgruppen-Einstellungen',
      SelectFilters: 'Filter auswählen',
      SelectedFilters: 'Ausgewählte Filter',

      AudienceListSetup: {
        Include: 'Einschließen',
        Exclude: 'Ausschließen',
        AudienceExistsMessage: `Kann {{audienceIncludeExclude}} Zielgruppe nicht erstellen, die bereits für {{audienceIncludeExcludeNoun}} festgelegt ist`,
        PickAudienceList: 'Zielgruppen-Liste auswählen',

        Includes: 'Einschließen',
        Excludes: 'Ausschließen',
        AudienceWarningMessage:
          'Die hochgeladene Zielgruppendatei wird nur verarbeitet, wenn sie von einem Bulk Actions Approver genehmigt wurde',
        SelectedFileForInclusion: 'Ausgewählte Datei für Einschließen',
        AudienceNotInTheList: 'Zielgruppe nicht in der Liste',
        IncludeAudienceFilenamePlaceholder: 'Name der Einschließungs-Zielgruppe',
        UploadNow: 'Jetzt hochladen',
        UploadNewList: 'Neue Liste hochladen',
        AcceptedFormat: 'Format akzeptiert: nur .xlsx/.csv-Dateien.',
        DownloadSample: 'Beispiel herunterladen',
        UploadExclusion: 'Ausschließen hochladen',
        SelectedFileForExclusion: 'Ausgewählte Datei für Ausschluss',
        ExcludeAudienceFilenamePlaceholder: 'Name der Ausschluss-Zielgruppe'
      },

      AudienceFilters: {
        Age: 'Alter',
        BirthMonth: 'Geburtsmonat',
        Gender: 'Geschlecht',
        Location: 'Standort',
        Loyalty: 'Treue',
        Personal: 'Persönlich',
        Custom: 'Benutzerdefiniert',
        EmailTags: 'Email-Tags',
        Ethnicity: 'Ethnie',
        SelectCustomerAttributeFilters: 'Wählen Sie Ihre Kundenattribute-Filter:',
        NoFiltersSelected: 'Keine Filter ausgewählt',
        And: 'und',
        Badge: 'Badge',
        Campaign: 'Kampagne',
        Leaderboard: 'Leaderboard',
        LoyaltyPoints: 'Loyalty Punkte',
        LoyaltyTier: 'Loyalty-Tier',
        MemberSince: 'Mitglied seit',
        Reward: 'Belohnung',
        PaymentBased: 'Zahlung basiert',
        Payment: 'Zahlung',
        SelectFilters: 'Filter auswählen, um eine Zielgruppenliste automatisch zu generieren',
        City: 'Stadt',
        States: 'Bundesländer',

        OfferId: 'Angebot ID',
        PrimaryClusterComb: 'Primärer Cluster-Kombination',
        PrimaryClusterState: 'Primärer Cluster-Status',
        Membership: 'Mitglied von',
        CurrentBirthday: 'Nur während des Geburtstags',
        CurrentBirthMonth: 'Nur während des Geburtsmonats',
        HasBirthday: 'Am Geburtstag',
        UserType: 'Benutzer-Typ',
        AccountConfirmedAt: 'Registriert zwischen',
        LoyaltyPointsBalance: 'Punkte-Saldo',
        CampaignEnrolment: 'Kampagne',
        LeaderboardPosition: 'Bestenlisten-Position',
        UPI: 'UPI',
        ScanPay: 'Scan-Zahlung',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Aktueller Standort',
        PaymentStatus: 'Zahlungsstatus',
        DaysPastDues: 'Tage überfällig',
        BNPLUnpaidEMIDate: 'BNPL unbezahltes EMI-Datum',
        InstaloanUnpaidEMIDate: 'Ratenkredit unbezahltes EMI-Datum',

        AgeFilter: {
          Title: 'Alter',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen',
          SelectPlaceholder: 'Einschließen',
          From: 'Alter von',
          FromPlaceholder: '18',
          To: 'bis',
          ToPlaceholder: '35',
          AddRange: 'Bereich hinzufügen',
          And: 'und',
          from: 'von'
        },
        BirthdayFilter: {
          Title: 'Geburtstag',
          SelectBirthMonth: 'Geburtsmonat auswählen',
          BirthMonth: 'Geburtsmonat',
          CurrentBirthMonth: 'Aktueller Geburtsmonat',
          OnlyDuringMonthOfBirth: 'Nur während des Geburtsmonats',
          HasBirthday: 'Geburtstag hat',
          OnBirthday: 'Am Geburtstag',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        GenderFilter: {
          Title: 'Geschlecht',
          SelectByGender: 'Geschlecht auswählen',
          Male: 'Männlich',
          Female: 'Weiblich'
        },

        EthnicityFilter: {
          Title: 'Ethnie',
          SelectEthnicity: 'Ethnie auswählen',
          SelectEthnicityPlaceholder: 'Ethnie auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        LocationFilter: {
          Title: 'Standort',
          SelectCity: 'Städte auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectCityPlaceholder: 'Städte auswählen',
          SelectState: 'Bundesland auswählen',
          SelectStatePlaceholder: 'Bundesland auswählen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen'
        },

        PersonalFilter: {
          Title: 'Persönlich',
          HubClub: 'Hub-Club',
          Select: 'Auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          AddCustomProperties: 'Benutzerdefinierte Eigenschaften hinzufügen',

          EnterKeyNameAndValueDetails: 'Schlüsselname und Wertdetails eingeben',
          SelectRelation: 'Beziehung auswählen',
          EnterNumber: 'Zahl eingeben',
          KeyValue: 'Schlüsselwert',
          DatePlaceholder: 'TT.MM.JJJJ',
          KeyNamePlaceholder: 'Schlüsselname',
          Is: 'Ist',
          True: 'Wahr',
          False: 'Falsch',
          And: 'UND',
          Or: 'ODER',
          CustomAttributeType: 'Benutzerdefiniertes Attribut-Typ #{{index}}',
          CustomAttribute: 'Benutzerdefiniertes Attribut #{{index}}',
          CustomAttributeOperator: 'Benutzerdefiniertes Attribut-Operator #{{index}}',
          CustomAttributeValue: 'Benutzerdefiniertes Attribut-Wert #{{index}}'
        },
        LoyaltyFilter: {
          Title: 'Treue',
          SelectLoyaltyProgram: 'Treue-Programm auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectProgram: 'Programm auswählen',
          Includes: 'Einschließen',
          Excludes: 'Ausschließen',
          UsersWithPointsBalance: 'Benutzer mit Punkt-Saldo',
          SelectLoyaltyProgramPlaceholder: 'Treue-Programm auswählen',
          From: 'Von',
          To: 'Bis',
          PointsBalanceFrom: 'Punkt-Saldo von',
          PointsBalanceTo: 'Bis'
        },

        EmailTagsFilter: {
          Includes: 'Einschließen',
          SelectEmailTags: 'Email-Tags auswählen',
          Excludes: 'Ausschließen'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Soziale Medien',
      OGTitle: 'Titel',
      OGDescription: 'Beschreibung',
      OGImage: 'Bild',
      OGImageAlt: 'Soziale Medien-Überprüfung',
      IOSAppLink: 'iOS App-Link',
      AndroidAppLink: 'Android App-Link',
      WebLink: 'Web-Link',
      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Eine iOS-, Android- oder Web-Link ist erforderlich',
      Allowed: 'Erlaubt: .jpg, .png, .svg',
      Browse: 'Durchsuchen',
      Recommended: 'Empfohlen: 720px by 120px',
      TitleIsRequired: 'Titel ist erforderlich.'
    },

    CampaignMechanics: {
      CampaignType: 'Kampagne-Typ',
      InstantReward: 'Sofortbelohnung',
      MultipleRuleCampaign: 'Mehrfachregelkampagne',
      Reward: 'Belohnung',
      Progress: 'Fortschritt',
      Raffle: 'Gewinnspiel',
      Stamp: 'Stempel',
      Game: 'Spiel',
      Quest: 'Quest',
      Referral: 'Referral',
      Survey: 'Umfrage',
      Quiz: 'Quiz',
      Streak: 'Serie',
      GiveRewardTitle: 'Sofort alle Belohnungen ausgeben',
      Yes: 'Ja',
      No: 'Nein',

      OutcomeType: 'Ergebnistyp',
      FixedPrize: 'Kunden erhalten einen festen Preis',
      ChoosePrize: 'Kunden wählen ihren bevorzugten Preis',

      GameTry: 'Spiel versuchen',
      AwardBadges: 'Abzeichen vergeben',
      AwardPoints: 'Punkte vergeben',
      AddRewards: 'Belohnungen hinzufügen',
      AddPrizeToSet: 'Preis zu Set hinzufügen',
      IncludeNoPrizeAsOutcome: 'Kein Preis als mögliches Ergebnis einschließen',
      RandomOutcomeSet: 'Zufälliges Ergebnis Set {{index}}',
      PrizeSet: 'Preisset {{index}}',

      LevelsAndPrizes: 'Level & Preise',
      LandingPage: 'Landingpage',
      ProgressMechanics: 'Progress Mechanik',

      InstantRewardMechanics: 'Sofortbelohnungs-Mechanik',
      ListCheckboxLabel: 'Kampagne in der Kampagnenliste des Benutzers anzeigen?',
      ListCheckboxSendPushNotificationLabel:
        'Push-Benachrichtigung bei jedem Regel-Auslöser senden?',
      MediaTagsToInclude: 'Medien-Tags zum Einbeziehen',
      SelectMediaTags: 'Medien-Tags auswählen',
      AddRule: 'Regel hinzufügen',
      Name: 'Name',
      Action: 'Aktion',
      Edit: 'Bearbeiten',
      Remove: 'Entfernen',

      IssuanceLimits: 'Ausgabebeschränkungen',
      TotalNumberOfIssuePrizeEventsOnCampaignLevel:
        'Gesamtanzahl der Ausgabe-Belohnungsereignisse (auf Kampagnenebene)',
      TotalNumberOfIssuePrizeEventsPerUser:
        'Gesamtanzahl der Ausgabe-Belohnungsereignisse (pro Benutzer)',
      IssuanceLimitsPerUser: 'Ausgabebeschränkungen (pro Benutzer)',
      IssuanceLimitsPerUserPlaceholder: '∞',
      IssuePrizeEvents: 'Ausgabe-Belohnungsereignis(se)',
      RateLimitOnCampaignLevel: 'Ratenbegrenzung (auf Kampagnenebene)',
      IssuePrizeEventsForEvery: 'Ausgabe-Belohnungsereignis(se) für jede(n)',
      Day: 'Tag',
      RateLimitPerUser: 'Ratenbegrenzung (pro Benutzer)',
      LimitTo: 'Begrenzen auf',
      LeaveTheLimitFieldsBlankForUnlimitedIssuePrizeEvents:
        '^ Feld leer lassen für unbegrenzte Ausgabe-Belohnungsereignisse',
      SvgHarmfulTagsRemovedSuccessfully: 'Schädliche SVG-Tags wurden erfolgreich entfernt!',
      ImageHelpText: '1:1 Seitenverhältnis empfohlen, maximal 500kb als JPG oder PNG',
      Upload: 'Hochladen',

      PrizeEarnedPopUp: 'Belohnung erhalten Pop-up',
      AppearsUponCustomerSignInToMicrosite: 'Erscheint beim Anmelden des Kunden auf der Microsite',
      Headline: 'Überschrift',
      PleaseInputYourHeadline: 'Bitte geben Sie Ihre Überschrift ein',
      SubHeadline: 'Unterüberschrift',
      PleaseInputYourSubHeadline: 'Bitte geben Sie Ihre Unterüberschrift ein',
      Image: 'Bild',
      ClaimPrizeButtonText: 'Button-Text zum Einlösen der Belohnung',
      PleaseInputClaimPrizeButtonText:
        'Bitte geben Sie den Button-Text zum Einlösen der Belohnung ein',

      AddTask: 'Aufgabe hinzufügen',
      SomethingWentWrong: 'Etwas ist schief gelaufen',
      MaxNumberReachedWarning: 'Limit von 10 Aufgaben pro Quest erreicht',
      TaskIndex: 'Aufgabe {{index}}',
      WinProbability: 'Gewinnchance:',
      WinProbabilityPercent: 'Gewinnchance %',
      loyaltypoints: 'treuepunkte',
      loyaltypoint: 'treuepunkt',

      StampRuleTable: {
        ID: 'ID',
        Name: 'Name',
        RuleType: 'Regeltyp',
        NumberOfStamps: 'Anzahl der Stempel',
        Action: 'Aktion',
        Edit: 'Bearbeiten',
        Remove: 'Entfernen'
      },

      SelectOutcomes: 'Belohnungen auswählen',
      OnlyRewardsWithConfiguredTags:
        'Nur Belohnungen mit konfigurierten Tags können ausgewählt werden, wenn Kunden ihren Preis wählen.',
      ConfigureRaffleCodes: {
        Title: 'Rafflecodes konfigurieren',
        SelectCodeType: 'Code-Typ auswählen',
        SystemGenerated: 'Systemgeneriert',
        UserUpload: 'Benutzer-Upload',
        TicketCodePrefix: 'Ticketcode-Präfix',
        LengthOfCode: 'Länge des Codes',
        NumberOfTickets: 'Anzahl der Tickets',
        CodeFormat: 'Code-Format',
        TotalPermutations: 'Gesamtanzahl Permutationen',
        SelectFile: 'Datei auswählen',
        UploadCodes: 'Codes hochladen',
        AcceptedFormats: 'Akzeptierte Formate: Nur .txt, .xlsx oder .csv Dateien.'
      },

      RaffleRules: {
        Title: 'Regeln zum Verdienen',
        AddRule: 'Regel hinzufügen'
      },

      GrandPrizes: {
        Title: 'Hauptpreise',
        LimitGrandPrizesToOnePerCustomerOnly: 'Hauptpreise auf einen pro Kunde beschränken',
        ThisSettingRequiresMultipleGrandPrizesToBeDefined:
          'Diese Einstellung erfordert, dass mehrere Hauptpreise definiert sind',
        AllocateRafflePrizesForIndividualPositionsOrARange:
          'Raffle-Preise für einzelne Positionen oder einen Bereich zuweisen. Z.B. Preisset 1 für den 1. Platz und Preisset 2 für die Plätze 2 bis 5.',
        AddPrizeSet: 'Preisset hinzufügen',
        Position: 'Position:',
        PrizeSetWithPositionStartsWith: 'Preisset {{index}}: Position beginnt mit',
        PrizeSetWithPosition: 'Preisset {{index}}: Position',
        PrizeSet: 'Preisset {{index}}',
        ConvertPositionToRange: 'Position in Bereich umwandeln'
      },

      OutcomeSettings: {
        Title: 'Ergebniseinstellungen – erscheint beim Anmelden des Kunden auf der Microsite',
        RaffleTicketOutcome: 'Raffle-Ticket-Ergebnis',
        GrandPrizeOutcome: 'Hauptpreis-Ergebnis',
        RaffleTicket: 'Raffle-Ticket',
        GrandPrize: 'Hauptpreis',
        Headline: 'Überschrift',
        Subheadline: 'Unterüberschrift',
        WinRewardGraphic: 'Belohnungsgrafik',
        ClaimPrizeButtonText: 'Button-Text zum Einlösen des Preises'
      },

      QuestMechanics: {
        Title: 'Quest-Mechanik',
        UserTriesValidity: 'Gültigkeit der Versuche pro Nutzer',
        UserTriesValidityPlaceholder: '100',
        UserTriesValidityPeriodPlaceholder: 'Tage',
        Hours: 'Stunden',
        Days: 'Tage',
        Months: 'Monate',
        Years: 'Jahre',
        TotalNumberofQuests:
          'Gesamtanzahl der Quests, die in einer Kampagne gestartet werden können',
        TotalNumberofQuestsPlaceholder: '∞',
        Quests: 'Quests',
        TotalNumberofQuestsPerUser:
          'Gesamtanzahl der Quests, die von jedem Nutzer gestartet werden können',
        TotalNumberofQuestsPerUserPlaceholder: '∞',
        LeaveTheLimitFieldsBlankForUnlimitedIssuances:
          '^ Limit-Feld leer lassen für unbegrenzte Ausgaben',
        QuestDisplaySetUp: 'Quest-Anzeige einrichten',
        Headline: 'Überschrift',
        SubHeadline: 'Unterüberschrift',
        BodyText: 'Haupttext',
        Image: 'Bild',
        ImageHelpText: 'Mindestgröße 360(B) x 144(H) px als JPG oder PNG',
        TasksDisplay: 'Aufgabenanzeige',
        TaskIndex: 'Aufgabe {{index}}',
        TaskDoneBadge: 'Abzeichen für erledigte Aufgabe',
        TaskDoneBadgeHelpText: 'B: 130px &times; H: 130px',
        TaskHeadline: 'Aufgabenüberschrift',
        TaskSubHeadline: 'Aufgabenunterüberschrift',
        TaskIcon: 'Aufgabensymbol',
        ButtonText: 'Button-Text',
        ButtonExternalLink: 'Externer Link für Button'
      },

      QuizQuestions: {
        Title: 'Fragen',
        AddQuestion: 'Frage hinzufügen',
        Type: 'Typ',
        TextQuestion: 'Textfrage',
        ImageQuestion: 'Bildfrage',
        WrittenResponse: 'Freitextantwort',
        MultipleAnswers: 'Mehrere Antworten',
        SingleAnswer: 'Einzelne Antwort',
        Question: 'Frage',
        Required: 'Erforderlich',
        Actions: 'Aktionen',
        Edit: 'Bearbeiten',
        Delete: 'Löschen',

        EditQuestion: 'Frage bearbeiten',
        UpdateQuestion: 'Frage aktualisieren',
        Cancel: 'Abbrechen',
        QuestionType: 'Fragetyp',
        TextChoice: 'Textauswahl',
        ImageChoice: 'Bildauswahl',
        CharactersLeft: 'Zeichen übrig',
        Description: 'Beschreibung',
        ImageHelpText: 'B: 360px &times; H: 145px | Erlaubt: .jpg, .jpeg, .png, .svg',
        LabelForQuestionImage: 'Beschriftung für das Fragebild',
        RequiredToAnswer: 'Antwort erforderlich',
        RequiredToAnswerDescription:
          'Teilnehmende können ihre Antwort in ein Textfeld eingeben, wie unten gezeigt:',
        InputFieldExample: 'Beispiel für Eingabefeld',
        AllowSelectingMultipleAnswers: 'Mehrfachauswahl erlauben',
        ChooseCorrectAnswer: 'Korrekte Antwort auswählen',
        IsSurveyChoice: 'Auswahl #{{index}}',
        AnswerChoice: 'Antwortauswahl #{{index}}',
        Option: 'Option #{{index}}',
        EachQuestionRequiresAtLeastTwoAnswers: 'Jede Frage benötigt mindestens zwei Antworten',
        AddAnother: 'Weitere hinzufügen',
        Answer: 'Antwort',

        ShowOthers: '„Andere (bitte angeben):“ anzeigen',
        Other: 'Andere (bitte angeben):',

        RequiredField: 'Dies ist ein Pflichtfeld!',
        YouNeedToTypeIn: 'Sie müssen eingeben',
        AnAnswer: 'eine Antwort',
        AQuestion: 'eine Frage',
        OrUploadAnImage: 'oder ein Bild hochladen',
        YouNeedToSelectMoreThanOneCorrectAnswer:
          'Sie müssen mehr als eine richtige Antwort auswählen',
        YouNeedToSelectAtLeastOneCorrectAnswer:
          'Sie müssen mindestens eine richtige Antwort auswählen',
        PleaseTypeInYourAnswer: 'Bitte geben Sie Ihre Antwort ein',

        Recommended: 'Empfohlen: 720px by 120px | Erlaubt: .jpg, .png, .svg',
        Upload: 'Hochladen'
      },

      QuizTimer: {
        Title: 'Quiz-Timer',
        SetATimeLimitForEachQuestion: 'Zeitlimit für jede Frage festlegen',
        CountUp: 'Aufwärts zählen',
        CountDown: 'Abwärts zählen',
        MaximumCount: 'Maximalanzahl',
        MaximumCountPlaceholder: '∞',
        Seconds: 'Sekunden'
      },

      QuizLimits: {
        Title: 'Quiz-Limits',
        SurveyLimits: 'Umfrage-Limits',
        QuizLimits: 'Quiz-Limits',
        AutoIssueMoves: 'Züge automatisch ausgeben',
        TotalLimitsInTheCampaignIs: 'Gesamtes {{campaingType}}-Limit in der Kampagne ist',
        InfiniteUses: 'HINWEIS: Für unbegrenzte Nutzung das Feld leer lassen.',
        IndividualUsersCanOnlyAttemptThisQuiz:
          'Einzelne Nutzer können dieses {{campaingType}} nur begrenzt versuchen',
        InfiniteUsers: 'HINWEIS: Für unbegrenzte Nutzer das Feld leer lassen.',
        TimesInTotal: 'Mal insgesamt',
        TimesPer: 'Mal pro',
        Day: 'Tag',
        Week: 'Woche',
        Month: 'Monat',
        Year: 'Jahr',
        BlockUsersWhoAchieved100PercentCorrect:
          'Benutzer blockieren, die 100 % der Antworten korrekt haben, sodass sie keine weiteren Versuche machen können',
        BlockUsersWhoAchieved100PercentCorrectNote:
          'HINWEIS: Sobald ein Kunde alle Fragen in diesem Quiz korrekt beantwortet hat, kann er das Quiz nicht erneut beantworten – unabhängig von verbleibenden Spielversuchen.'
      },

      QuizValidity: {
        Survey: 'Umfrage',
        Quiz: 'Quiz',
        Title: '{{campaingType}}-Gültigkeit',
        AfterIssueTheQuizWillExpireIn: 'Nach Ausgabe läuft das {{campaingType}} ab in',
        QuizLimitPlaceholder: '100',
        Days: 'Tage',
        Months: 'Monate',
        Years: 'Jahre'
      },
      QuizGraphicsSettings: {
        Title: 'Quiz-Eigenschaften',
        AppBackground: 'App-Hintergrund',
        FontColour: 'Schriftfarbe',
        CTAButtonBackgroundColour: 'CTA-Button-Hintergrundfarbe',
        CTAButtonTextColour: 'CTA-Button-Schriftfarbe',
        HelpText: 'B: 375px &times; H: 812px'
      },
      MicrositeGraphicsSettings: {
        Title: 'Microsite-Anzeigeeigenschaften',
        LandingScreen: 'Startbildschirm',
        OutcomeSettings: 'Ergebniseinstellungen',
        Body: 'Text',
        InsertYouTubeEmbedURLHere: 'YouTube-Einbettungs-URL hier einfügen',
        ButtonText: 'Button-Text',
        OutcomeSettingsScoreResult: 'Ergebniseinstellungen',
        SuccessfulOutcomeHeadline: 'Überschrift für erfolgreiches Ergebnis',
        SuccessfulOutcomeBody: 'Text für erfolgreiches Ergebnis',
        SuccessfulOutcomeImage: 'Bild für erfolgreiches Ergebnis',
        SuccessfulOutcomeImageHelpText: 'B: 400px &times; H: 400px',
        SuccessfulOutcomeButton: 'Button für erfolgreiches Ergebnis',
        NoOutcomeTitle: 'Titel für kein Ergebnis',
        NoOutcomeSubheadline: 'Unterüberschrift für kein Ergebnis',
        NoOutcomeImage: 'Bild für kein Ergebnis',
        NoOutcomeButton: 'Button für kein Ergebnis'
      },
      CampaignSelectModal: {
        Title: 'Kampagne auswählen',
        OkText: 'Kampagne hinzufügen',
        CancelText: 'Abbrechen',
        SearchPlaceholder: 'Kampagne nach Name, Typ oder Händler suchen',
        Name: 'Name',
        Status: 'Status',
        Tags: 'Tags',
        StartDate: 'Startdatum',
        EndDate: 'Enddatum',
        Active: 'Aktiv',
        Scheduled: 'Geplant'
      }
    },

    Outcomes: {
      SelectOutcomes: 'Belohnungen auswählen',
      Name: 'Name',
      Action: 'Aktion',
      EditPoints: 'Punkte bearbeiten',
      Remove: 'Entfernen',
      EditReferralRule: 'Referral-Regel bearbeiten',
      MoveToTop: 'Nach oben verschieben',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo',
      PointsAwarded: 'Punkte vergeben',
      ReferrerLimits: 'Referrer-Limits',
      ReferralsNeeded: 'Referrals benötigt',
      RefereeRewardLimit: 'Referee-Belohnungssaldo',
      AwardBadges: 'Belohnungen auswählen',
      AwardPoints: 'Punkte vergeben',
      AddRewards: 'Belohnungen hinzufügen'
    },

    CampaignRules: {
      AddRule: 'Regel hinzufügen'
    },
    RuleGroup: {
      Mechanic: 'Mechanik'
    },

    RefferalSelectionModal: {
      Title: 'Referral-Regel bearbeiten',
      OnCancelError: 'Referral-Wert ist keine Zahl! Bitte überprüfen Sie es!',
      OkButtonText: 'OK',
      RewardId: 'Belohnung ID:',
      Referee: 'Referee',
      Referrer: 'Referrer',
      NoOfReferralsNeeded: 'Anzahl der Referrals benötigt',
      TotalRewardLimit: 'Gesamte Belohnungssaldo',
      RewardLimit: 'Belohnungssaldo',
      RewardBalance: 'Belohnungssaldo : ',
      CheckboxError: 'Referrer oder Referee-Optionen sind erforderlich',
      RewardIDTitle: 'Belohnung ID:',
      Points: 'Punkte',
      Of: ' von ',
      TotalOutcomeLimit: 'Gesamte Belohnungssaldo',
      OutcomeLimit: 'Belohnungssaldo',
      NumberError: 'Diese Wert muss eine Zahl sein',
      RequiredError: 'Dieser Wert ist erforderlich'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Belohnungen suchen',
      Active: 'Aktiv',
      Private: 'Privat',
      Approved: 'Genehmigt',
      System: 'System',
      SelectRewards: 'Belohnungen auswählen',
      Back: 'Zurück',
      Next: 'Weiter',
      Done: 'Fertig',
      Name: 'Name',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo',
      SetupReferralRule: 'Referral-Regel einrichten'
    },

    RewardPicker: {
      SelectRewards: 'Belohnungen auswählen',
      OkButtonText: 'Belohnungen hinzufügen',
      SearchRewards: 'Finde eine neue Belohnung nach Name, Typ oder Händler',
      Active: 'Aktiv',
      Private: 'Privat',
      Approved: 'Genehmigt',
      System: 'System',
      Ended: 'Beendet',
      Inactive: 'Inaktiv',
      Draft: 'Entwurf',
      Name: 'Name',
      MerchantName: 'Händler Name',
      SellingFrom: 'Verkauf startet am',
      SellingTo: 'Verkauf endet am',
      RewardBalance: 'Belohnungssaldo'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Bitte wählen Sie einen GL-Konto',
      PleaseSelectGLAccountTypeAndName: 'Bitte wählen Sie ein GL-Konto, Typ und Name',
      PleaseSetNumberOfPointsToAward: 'Bitte setzen Sie die Anzahl der zu vergebenden Punkte',
      SetPointsToAward: 'Punkte setzen',
      Next: 'Weiter',
      Done: 'Fertig',
      SelectLoyaltyProgram: 'Treue-Programm auswählen',
      HowManyPoints: 'Wie viele Punkte?',
      SelectGLAccount: 'GL-Konto auswählen',
      SelectGLAccountType: 'GL-Konto-Typ auswählen',
      SelectGLAccountName: 'GL-Konto-Name auswählen',
      SelectGLAccountNamePlaceholder: 'Name',
      EnterPoints: 'Punkte eingeben',
      SetupReferralRule: 'Referral-Regel einrichten',
      AwardedPointsExpireIn: 'Awarded points expire in',
      NumberOfDaysPlaceholder: 'e.g., 7',
      Days: 'days'
    },

    GameTypesSelectModal: {
      Title: 'Wähle einen Spieltyp',
      OkButtonText: 'Auswählen',
      CancelButtonText: 'Abbrechen',

      ShakeTheTree: {
        Title: 'Schüttel den Baum',
        InstructionsLineOne:
          'Binde Kunden mit einer Herausforderung ein, bei der sie das Telefon schütteln müssen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Schütteln des Baums',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      HitThePinata: {
        Title: 'Triff die Piñata',
        InstructionsLineOne:
          'Binde Kunden mit einer Herausforderung ein, bei der sie die Piñata treffen müssen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Treffen der Piñata',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      ScratchCard: {
        Title: 'Rubbelkarte',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie rubbeln und aufregende Preise gewinnen können',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Rubbeln der Karte',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      SpinTheWheel: {
        Title: 'Dreh das Rad',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie das Rad drehen und aufregende Preise gewinnen können',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Drehen des Rads',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          'Binde Kunden ein, indem sie ihr Glück versuchen, den Ball in das Gewinnfeld zu bekommen',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Endbenutzer erhält eine Belohnung basierend auf der Ausführung einer erforderlichen Aktion, in diesem Fall durch Fallenlassen des Balls',
        InstructionsLineFour:
          '2. Belohnungen werden zufällig basierend auf der für die Belohnungen festgelegten Wahrscheinlichkeit vergeben',
        InstructionsLineFive: 'Ideal für',
        InstructionsLineSix: '1. Saisonales Spiel'
      },
      BubblePop: {
        Title: 'Blasen-Pop',
        InstructionsLineOne:
          'Begeistern Sie Kunden mit einer schnellen, spaßigen Herausforderung, die echte Belohnungen bietet',
        InstructionsLineTwo: 'Spielmechanik',
        InstructionsLineThree:
          '1. Der Benutzer erzielt Punkte, indem er innerhalb von 30 Sekunden auf farbige Blasen tippt',
        InstructionsLineFour:
          '2. Jede Blasenfarbe hat unterschiedliche positive oder negative Punkte — also mit Bedacht platzen lassen',
        InstructionsLineFive:
          '3. Abhängig von ihrer Endpunktzahl erhalten Nutzer sofort Treuepunkte, Gutscheine, Spielversuche oder Los-Tickets',
        InstructionsLineSix:
          '4. Je höher die Punktzahl, desto besser die Belohnung — reines Können, kein Zufall',
        InstructionsLineSeven: 'Ideal für',
        InstructionsLineEight:
          'Kampagnen, bei denen Sie Engagement belohnen möchten, nicht nur Glück'
      }
    },
    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Streak-Kampagnentyp auswählen',
      ContinuousLoop: 'Kontinuierliche Schleife',
      MilestoneBased: 'Meilensteinbasiert',
      TransactionCount: 'Transaktionsanzahl',
      Progressive: 'Progressiv',
      CheckIn: 'Check-in',
      CumulativeSpend: 'Kumulierte Ausgaben',
      ContinuousLoopDescription:
        'Halten Sie Kunden engagiert, indem sie Aufgaben wiederholt innerhalb eines festen Zeitraums ausführen und jedes Mal eine Belohnung erhalten.',
      GameMechanicsTitle: 'Spielmechanik',
      ContinuousLoopGameMechanicsLineOne:
        '1. Das Spiel hat einen festen Zeitraum – täglich, wöchentlich oder monatlich.',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Benutzer müssen eine bestimmte Aufgabe mehrmals innerhalb des Zeitraums ausführen. Wenn sie alle Aufgaben abgeschlossen haben, erhalten sie eine Belohnung, und die Kampagne startet automatisch in der nächsten Periode neu.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. Wenn Kunden eine Serie verpassen, beginnen sie im nächsten Serienzeitraum erneut.',
      ContinuousLoopIdealForTitle: 'Ideal für',
      ContinuousLoopIdealForLineOne: '1. Tägliche Check-in-Kampagnen',

      MilestoneBasedDescription:
        'Setzen Sie progressive Ziele für Ihre Kunden, um wiederholte Aufgaben auszuführen, mit einer Belohnung für jeden erreichten Meilenstein.',
      MilestoneBasedGameMechanicsTitle: 'Spielmechanik',
      MilestoneBasedGameMechanicsLineOne:
        '1. Das Spiel hat ein festes Intervall – täglich, wöchentlich oder monatlich.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. Das Spiel erfordert eine definierte Aufgabe, die wiederholt ausgeführt werden muss – z. B. Anmeldung, bestimmte Transaktion usw.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Definieren Sie Meilensteine basierend darauf, wie viele Aufgaben und über wie viele aufeinanderfolgende Perioden sie ausgeführt werden müssen.',
      MilestoneBasedGameMechanicsLineFour:
        '4. Kunden erhalten eine Belohnung, wenn sie den Meilenstein erreichen. Wenn sie eine Serie verpassen, beginnen sie erneut beim aktuellen Meilenstein. Belohnungen werden nur einmal pro Meilenstein vergeben.'
    },

    TeamsMechanics: {
      Title: 'Team-Mechanik',
      Description:
        'Team-Mechanik-Einstellungen können nach Veröffentlichung einer Kampagne nicht mehr aktualisiert werden.',
      ActivateTeamMechanics: 'Team-Mechanik aktivieren',
      TeamSize: 'Benutzer pro Team',
      LandingScreen: 'Startbildschirm',
      Image: 'Bild',
      ImageHelpText: 'Mindestgröße 360(B) x 144(H) px in jpg oder png',
      PreEnrollmentMessage: 'Voranmeldungsnachricht',
      StampsEarnMessage: 'Stempel-Sammelnachricht',
      GameplayInstructions: 'Spielanleitung',
      JoinTeamPage: 'Team beitreten Seite',
      JoinTeamInfoMessage: 'Team beitreten Info-Nachricht',
      InviteMemberMessage: 'Mitglied einladen Nachricht',
      InviteCodeBlurb: 'Einladungscode Text',
      CharactersUsed: 'Verwendete Zeichen',
      Note: 'Hinweis',
      NoteDescriptionOne: 'Sowohl die',
      NoteDescriptionTwo: 'Mitglied einladen Nachricht',
      NoteDescriptionThree: 'als auch der',
      NoteDescriptionFour: 'Einladungscode Text',
      NoteDescriptionFive:
        'werden verwendet, um die "Teilen-Nachricht" zu generieren. Wir haben keine Beschränkung für die Länge dieser Nachricht festgelegt - beachten Sie jedoch, dass SMS-Nachrichten auf 160 Zeichen pro Nachricht begrenzt sind',

      DefaultPreEnrollmentMessagePartOne:
        'Erstellen oder treten Sie einem {{teamSize}}-Personen-Team bei',
      DefaultPreEnrollmentMessagePartTwo: 'Sie können 1 Team erstellen oder einem beitreten.',
      DefaultStampsEarnMessagePartOne: 'Sammeln Sie Stempel durch folgende Aktivitäten',
      DefaultStampsEarnMessagePartTwo: 'KYC durchführen',
      DefaultStampsEarnMessagePartThree: 'Auf E-Statements umstellen',
      DefaultParticipationInfoMessagePartOne:
        'Verdienen Sie Belohnungen durch folgende Aktivitäten',
      DefaultParticipationInfoMessagePartTwo: 'KYC durchführen',
      DefaultParticipationInfoMessagePartThree: 'Auf E-Statements umstellen',
      DefaultTeamCompleteButtonText: 'Ihren Fortschritt prüfen',
      DefaultTeamCompleteButtonTextStamp: 'Ihre Stempelkarten ansehen',
      DefaultTeamIncompleteButtonText: 'Einem Team beitreten',
      DefaultTeamIncompleteButtonTextSecondary: 'Ein Team erstellen',
      DefaultJoinTeamPageDescriptionPartOne:
        'Ein Team gilt erst als aktiv, wenn {{teamSize}} Mitglieder beigetreten sind.',
      DefaultJoinTeamPageDescriptionPartTwo:
        'Geben Sie den Code/URL im obigen Feld ein und klicken Sie auf Beitreten',
      DefaultJoinTeamPageDescriptionPartThree:
        'Warten Sie, bis {{teamSize}} Mitglieder beigetreten sind',
      DefaultJoinTeamPageDescriptionPartFour: 'Sammeln Sie Stempel als Team',
      DefaultJoinTeamPageDescriptionPartFive: 'Spielen Sie Spiele als Team',
      DefaultJoinTeamPageDescriptionPartSix:
        'Einzelpersonen können nur Teil von 1 Team sein (egal ob erstellt oder beigetreten)',
      DefaultInviteMessageDescriptionPartOne: 'Hallo, bitte tritt meinem Team bei, um',
      DefaultInviteMessageDescriptionPartTwo: ' Stempelkarten auszufüllen ',
      DefaultInviteMessageDescriptionPartThree: ' Spiele zu spielen ',
      DefaultInviteMessageDescriptionPartFour: ' und gemeinsam Preise zu gewinnen!',
      DefaultInviteMessageCodeBlurb: 'Nutze meinen Team-Code:'
    },

    EnrolMechanics: {
      EnrolmentMechanics: 'Anmelde-Mechanik',
      AutoEnrolUsers: 'Benutzer automatisch anmelden',
      EnrollableUntil: 'Anmeldbar bis',
      AutoFillStamps: 'Stempel automatisch ausfüllen',
      EnableCampaignDurationMechanics: 'Kampagnendauer-Mechanik aktivieren',
      UsersMustCompleteTheCampaignWithin: 'Benutzer müssen die Kampagne abschließen innerhalb von',
      AutoRedeemOutcome: 'Ergebnis automatisch einlösen',
      SendMicrositeNotification:
        'Microsite-Benachrichtigung für automatisch eingelöstes Ergebnis senden?',
      Yes: 'Ja',
      No: 'Nein'
    },

    StreakMechanics: {
      StreakMechanics: 'Serienmechanik',
      SelectTaskType: 'Aufgabentyp auswählen',
      CumulativeSpend: 'Kumulierte Ausgaben',
      TransactionCount: 'Transaktionsanzahl',
      SignIn: 'Anmelden',
      StreakRequirements: 'Serienanforderungen',
      TargetCriteria: 'Zielkriterien',
      UserMustPerformTheTask: 'Der Benutzer muss die Aufgabe ausführen',
      TimesWithinOne: 'Mal innerhalb von 1',
      StreakTarget: 'Serienziels',
      Continuous: 'aufeinanderfolgende',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      SelectTrigger: 'Auslöser auswählen',
      MilestonesAndPrizes: 'Meilensteine und Preise',
      TargetMake: 'Ziel: Durchführen',
      ValidTransactionsEvery: 'gültige Transaktionen alle',
      For: 'für',
      Level: 'Ebene',
      MustBeMoreThanLevel: 'muss höher als Ebene sein',
      SelectStreakDuration: 'Seriendauer auswählen',
      Daily: 'Täglich',
      Weekly: 'Wöchentlich',
      Monthly: 'Monatlich',
      AtLeastOneConditionIsRequired: 'Mindestens eine Bedingung ist erforderlich',
      CustomerSignIn: 'Kundenanmeldung',
      TransactionCreated: 'Transaktion erstellt',
      TargetSpend: 'Ziel: Ausgaben',
      CurrencyEvery: 'Währung alle',
      TargetSignIn: 'Ziel: Anmeldung',
      TimesEvery: 'Mal alle',
      Perform: 'ausführen',
      Signin: 'anmelden',
      Transaction: 'Transaktion',
      Spend: 'ausgeben',
      PerformTheTask: 'die Aufgabe ausführen',
      InOrderToWinThePrize: 'um den Preis zu gewinnen',
      MakeTransactionAtLeast: 'Transaktion mindestens durchführen',
      Times: 'Mal',
      AtLeast: 'mindestens',
      Where: 'wo',
      CurrencyOnTransactionsWhere: 'Währung, bei Transaktionen, bei denen',
      MakeTransaction: 'Transaktion durchführen'
    },

    LandingPage: {
      Title: 'Startseite',
      Headline: 'Überschrift',
      SubHeadline: 'Unterüberschrift',
      BodyText: 'Text',
      Image: 'Bild',
      CTAButtonText: 'CTA Button Text',
      CTAButtonColour: 'CTA Button Farbe',
      CTAButtonTextColour: 'CTA Button Text Farbe',
      TermsAndConditions: 'AGB',
      EnrolmentMessage: 'Anmeldungsnachricht',
      ImageHelpText: '16:9 Seitenverhältnis empfohlen, maximal 500kb im JPG- oder PNG-Format',
      IssuePrizeDescription: 'Beschreibung der Preisvergabe',
      IssuePrizeDescriptionPlaceholder: 'Bitte geben Sie die Beschreibung der Preisvergabe ein',
      PleaseInputYourHeadline: 'Bitte geben Sie Ihre Überschrift ein',
      PleaseInputYourSubHeadline: 'Bitte geben Sie Ihre Unterüberschrift ein',
      PleaseInputYourBodyText: 'Bitte geben Sie Ihren Text ein',

      ImageMinRequirements: 'Mindestgröße 360(B) x 144(H) px im JPG- oder PNG-Format',
      AspectRatioRecommendation: '16:9-Seitenverhältnis empfohlen, maximal 500 KB in jpg oder png',

      LevelsTab: "Registerkarte 'Levels'",
      HowToParticipateTab: "Registerkarte 'So funktioniert es'",
      TabName: 'Registerkartenname',
      CampaignPointsShortForm: 'Abkürzung für Kampagnenpunkte',
      LevelProgressBadges: 'Levelfortschritt-Abzeichen',
      LevelCompletedBadge: "Abzeichen 'Level abgeschlossen'",
      LevelInProgressBadge: "Abzeichen 'Level in Bearbeitung'",
      LevelNotStartedBadge: "Abzeichen 'Level nicht gestartet'",
      LevelCompletedBadgeHelpText: 'Empfohlen: 92px x 92px, maximal 100kb im JPG- oder PNG-Format',
      IssuePrizelabel: "Beschreibung 'Preis ausgeben'",
      LevelCompletedBadgeIcon: 'Symbol Registerkarte {{index}}',
      Text: 'Text',

      CompleteLevelAndStandToWinAPrizeSetIncluding: 'Level abgeschlossen & Preisset gewinnen:',
      AddLevel: 'Level hinzufügen',
      ParticipateAndWinExcitingPrizes: 'Spielen und gewinnen Sie aufregende Preise!',
      HowToParticipate: 'So funktioniert es',
      PointsRequiredForCampaignCompletion: 'Erforderliche Gesamtkampagnenpunkte für dieses Level:',

      OutcomeSettings: {
        Title: 'Ergebnis-Einstellungen',
        Badges: 'Abzeichen',
        Vouchers: 'Gutscheine',
        Points: 'Punkte',
        PrizeSet: 'Preisset',
        MixedRewards: 'Gemischte Belohnungen',
        Submit: 'Absenden',
        MixedRewardsButtonText: 'Button-Text basierend auf der ersten aufgeführten Belohnung',
        Headline: 'Überschrift',
        CharactersLeft: 'Zeichen übrig',
        MixedRewardsMessage:
          'Bei einem Preisset basieren der Button-Text und die Aktion auf der ersten in den Ergebnissen aufgeführten Belohnung.',
        ButtonText: 'Button-Text',
        Graphic: 'Grafik',
        GraphicHelpText: 'B: 400px × H: 400px',

        BadgesHeadline: 'Glückwunsch! Sie haben ein Abzeichen gewonnen!',
        BadgesButtonText: 'Meine Abzeichen anzeigen',
        VouchersHeadline: 'Glückwunsch! Sie haben einen Gutschein gewonnen!',
        VouchersButtonText: 'Zu meinen Gutscheinen',
        PointsHeadline: 'Glückwunsch! Sie haben Punkte gewonnen!',
        PointsButtonText: 'Meine Punkte ansehen',
        MixedRewardsHeadline: 'Glückwunsch! Sie haben Belohnungen gewonnen!'
      },

      EndsOnDate: 'Endet am {{date}}',
      FromDate: 'Ab dem {{date}}',
      ParticipateAndStandToWin: 'Nehmen Sie teil und gewinnen Sie EINES der folgenden:',
      CongratsYouEarnedAPrize: 'Glückwunsch, Sie haben einen Preis gewonnen!',
      ClaimNowBeforeTheRunOut: 'Jetzt sichern, bevor sie vergriffen sind!',
      ClaimPrize: 'PREIS EINLÖSEN',

      Levels: 'Levels',
      PointsAbbreviation: 'CP'
    },

    StampCampaign: {
      Config: {
        Title: 'Anzahl der Stempel auswählen',
        TotalStampsOnCard: 'Gesamtzahl der Stempel auf der Karte',
        TotalStamps: 'Gesamtzahl der Stempel',
        StampsPerRow: 'Anzahl der Stempel pro Reihe (max. 5)',
        StampsPerRowPlaceholder: '(Optional) Stempel pro Reihe angeben',
        StampsPerColumn: 'Anzahl der Stempel pro Spalte',
        StampsPerColumnPlaceholder: '(Optional) Stempel pro Spalte angeben'
      },
      TriggerConfig: {
        Title: 'Stempel-Sammelregeln festlegen'
      },
      CardBackground: {
        Title: 'Kartenbild',
        HeaderMessage: 'Überschrift',
        Subheadline: 'Unterüberschrift',
        Backgrounds: 'Hintergründe',
        BackgroundImage: 'Hintergrundbild',
        RemoveImage: 'Bild entfernen',
        BrowseFiles: 'DATEIEN DURCHSUCHEN',
        CardBackgroundImage: 'Karten-Hintergrundbild',
        CardBackgroundImageAlt: 'Stempelkarten-Hintergrund',
        ThumbnailImage: 'Vorschaubild',
        ThumbnailImageAlt: 'Stempel-Vorschau',
        Elements: 'Elemente',
        GiftActive: 'Geschenk (Aktiv)',
        GiftActiveAlt: 'Geschenk',
        GiftInactive: 'Geschenk (Inaktiv)',
        GiftInactiveAlt: 'Geschenk (Inaktiv)',
        StampActive: 'Stempel (Aktiv)',
        StampActiveAlt: 'Stempel',
        StampInactive: 'Stempel (Inaktiv)',
        StampInactiveAlt: 'Stempel (Inaktiv)',
        ButtonText: 'Button-Text',
        ButtonExternalLink: 'Externer Button-Link',
        ButtonColour: 'Button-Farbe',
        ButtonTextColour: 'Button-Textfarbe'
      },
      LimitConfig: {
        Title: 'Stempel-Limits',
        TotalStampCards: 'Gesamtzahl Stempelkarten',
        TotalStampCardsPerUser: 'Stempelkarten pro Benutzer',
        TotalStamps: 'Gesamtzahl Stempel',
        TotalStampsPerUser: 'Stempel pro Benutzer',
        Every: 'alle',
        Days: 'Tage',
        Months: 'Monate',
        Year: 'Jahr',
        Weeks: 'Wochen'
      },

      AutoEnrolMechanic: {
        Title: 'Kampagne-Mechanik',
        OperatingDays: 'Betriebstage',
        From: 'Von',
        To: 'Bis'
      }
    },

    Referral: {
      Title: 'Referral-Code-Typen',
      CodeType: 'Code-Typ',
      ReferredBy: 'Referral-von',
      SelectFile: 'Datei auswählen',
      SystemGenerated: 'System generiert',
      AlternateId: 'Alternativer ID',
      User: 'Benutzer',
      Partner: 'Partner',
      ActionMechanics: 'Aktion-Mechanik',

      UploadSingleFileFiled: {
        AcceptedFormat: 'Akzeptierte Formate: {{acceptedFormatsString}} Dateien nur',
        DownloadSample: 'Beispiel herunterladen',
        ChooseFile: 'Datei auswählen'
      }
    },

    CampaignRulesTable: {
      Outcome: 'Ergebnis',
      Priority: 'Priorität',
      TriggerLimitPerUser: 'Auslöselimit pro Benutzer',
      TotalTriggerLimit: 'Gesamtes Auslöselimit',

      Name: 'Name',
      CampaignPointsIssued: 'Kampagne-Punkte ausgegeben',
      Action: 'Aktion',
      Edit: 'Bearbeiten',
      Remove: 'Entfernen'
    },

    RuleGroupLandingPage: {
      Title: 'Landingpage',
      Headline: 'Überschrift',
      HeadlinePlaceholder: 'Bitte geben Sie Ihre Überschrift ein',
      SubHeadline: 'Unterüberschrift',
      SubHeadlinePlaceholder: 'Bitte geben Sie Ihre Unterüberschrift ein',
      BodyText: 'Text',
      Image: 'Bild',
      ImageHelpText: '16:9 Seitenverhältnis empfohlen, maximal 500kb als jpg oder png',
      ExpandableContentSections: 'Erweiterbare Inhaltsabschnitte',
      SectionLabel: 'Abschnitt {{index}} Bezeichnung',
      SectionHeaderText: 'Abschnitt {{index}} Überschrift',
      SectionBodyText: 'Abschnitt {{index}} Text',

      ExpandableSection: 'Erweiterbarer Abschnitt',
      Label: 'Bezeichnung',
      AddSection: 'Abschnitt hinzufügen',
      Remove: 'Entfernen',
      ShopChooseRedeem: 'Shop. Wählen. Einlösen.'
    },

    RuleGroupEnrolmentPage: {
      Title: 'Anmelde-Seite',
      BodyText: 'Text'
    },

    GameSettings: {
      ShakeTheTreeSettings: 'Shake The Tree Einstellungen',
      HeaderMessage: 'Kopfzeilen-Nachricht',
      Header: 'Kopfzeile',
      CharactersLeft: 'verbleibende Zeichen',
      HeadlineTextColour: 'Textfarbe der Überschrift',
      Subheadline: 'Unterüberschrift',
      Description: 'Beschreibung',
      GameDesign: 'Spieldesign',
      BackgroundImage: 'Hintergrundbild',
      TreeImage: 'Baumbild',
      GiftIcon: 'Geschenksymbol',
      GiftIconOpenState: 'Geschenksymbol - geöffneter Zustand',
      NumberOfGiftIcons: 'Anzahl der Geschenksymbole',
      SubheadlineTextColour: 'Textfarbe der Unterüberschrift',
      NumberOfTaps: 'Anzahl der Tippvorgänge',
      PinataSettings: 'Pinata Einstellungen',
      AppBackground: 'App-Hintergrund',
      FontColour: 'Schriftfarbe',
      InitialPinata: 'Anfangs-Piñata',
      CrackingPinata: 'Zerbrechende Piñata',
      BrokenPinata: 'Zerbrochene Piñata',
      ButtonText: 'Schaltflächentext',
      ButtonColour: 'Schaltflächenfarbe',
      ButtonTextColour: 'Textfarbe der Schaltfläche',
      DisplayProperties: 'Anzeigeeigenschaften',
      Headline: 'Überschrift',
      AppGraphics: 'App-Grafiken',
      ScratchCardGraphics: 'Rubbellos-Grafiken',
      PreScratch: 'Vor dem Rubbeln',
      PostSuccess: 'Nach (Erfolg)',
      PostFail: 'Nach (Fehlschlag)',
      SubheadlineColour: 'Farbe der Unterüberschrift',
      ScratchCardHeadline: 'Überschrift des Rubbelloses',
      SpinTheWheelHeadline: 'Überschrift von Spin The Wheel',
      SpinTheWheelGraphics: 'Grafiken für Spin The Wheel',
      RewardIcon: 'Belohnungssymbol',
      NumberOfWedges: 'Anzahl der Segmente',
      NumberOfWedgesOnTheWheel: 'Anzahl der Segmente auf dem Rad',
      Wedge: 'Segment',
      Color: 'Farbe',
      HasReward: 'Hat Belohnung',
      RimImage: 'Randbild',
      WheelPosition: 'Position des Rades',
      Center: 'Zentrum',
      Bottom: 'Unten',
      PointerImage: 'Zeigerbild',
      PlinkoSettings: 'Plinko-Einstellungen',
      Plinko: 'Plinko!',
      PlinkoGraphics: 'Plinko-Grafiken',
      FrameColour: 'Rahmenfarbe',
      BallColour: 'Ballfarbe',
      GameDuration: 'Spieldauer',
      HowLongItTakesForTheBallToReachTheBottom:
        'Wie lange der Ball braucht, um den Boden zu erreichen',
      Seconds: 'Sekunden',
      SuggestedDuration: 'Empfohlene Dauer: 3–5 Sekunden',
      TargetType: 'Zieltyp',
      Bubble: 'Blase',
      Coins: 'Münzen',
      Stars: 'Sterne',
      BubbleSpawnRate: 'Blasen-Spawnrate',
      Easy: 'Einfach',
      Medium: 'Mittel',
      Hard: 'Schwierig',
      CTAButtonText: 'CTA-Schaltflächentext',
      CTAButtonColour: 'CTA-Schaltflächenfarbe',
      CTAButtonTextColour: 'CTA-Schaltflächentextfarbe',
      NumberOfBubbles: 'Bubble Pop Grafiken',
      BubbleLabel: 'Blase',
      GameSettings: 'Bubble Pop Einstellungen',
      GameBackground: 'Spielhintergrund',
      CustomSpawnRate: 'Benutzerdefinierte Spawnrate',
      MaxBubbles: 'Max Blase',
      SpawnInterval: 'Spawn-Intervall (in Millisekunden)',
      BubblesPerSpawn: 'Blase pro Spawn',
      BubbleLifetime: 'Lebensdauer der Blase (in Millisekunden)',
      GameDurationNote: 'HINWEIS: Eine Spieldauer von mindestens 10 Sekunden ist erforderlich.',
      MaxBubblesNote: 'HINWEIS: Maximale Anzahl der auf dem Bildschirm anzuzeigenden Blasen.',
      SpawnIntervalNote: 'HINWEIS: Blasen-Erscheinungsintervall in Millisekunden',
      BubblesPerSpawnNote: 'HINWEIS: Anzahl der gleichzeitig erzeugten Blasen.',
      BubbleLifetimeNote: 'HINWEIS: Lebensdauer der Blase in Millisekunden',
      Type: 'Typ',
      CustomImage: 'Benutzerdefiniertes Bild',
      SVGCode: 'SVG-Code',
      DownloadSampleSVG: 'Beispiel-SVG herunterladen',
      Points: 'Punkte',
      MarkAsBonus: 'Als Bonus markieren',
      BonusImageOccurrence: 'Anzahl der Bonusblase Vorkommen'
    },

    OutcomeSettings: {
      OutcomeSettings: 'Ergebniseinstellungen',
      WinRewardTitle: 'Titel der gewonnenen Belohnung',
      CharactersLeft: 'verbleibende Zeichen',
      WinRewardSubheadline: 'Unterüberschrift der gewonnenen Belohnung',
      WinRewardGraphic: 'Grafik der gewonnenen Belohnung',
      NoOutcomeTitle: 'Titel ohne Ergebnis',
      NoOutcomeSubheadline: 'Unterüberschrift ohne Ergebnis',
      NoOutcomeGraphic: 'Grafik ohne Ergebnis',
      WinRewardButton: 'Schaltfläche für die gewonnene Belohnung',
      NoOutcomeButton: 'Schaltfläche ohne Ergebnis'
    },

    GameLimits: {
      GameLimits: 'Spielbegrenzungen',
      AutoIssueMoves: 'Automatische Spielzüge ausgeben',
      AlwaysShowThisCampaignEvenIfOutOfGameTries:
        'Diese Kampagne immer anzeigen, auch wenn keine Spielversuche mehr verfügbar sind',
      TotalGameCampaignLimitsIs: 'Das Gesamtlimit der Spielkampagne beträgt',
      NoteForInfiniteUsesLeaveBlank: 'HINWEIS: Für unbegrenzte Nutzung Feld leer lassen.',
      IndividualUsersCanOnlyPlayThisGame: 'Einzelne Benutzer können dieses Spiel nur',
      TimesInTotal: 'Mal insgesamt spielen',
      TimesPer: 'Mal pro'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Spielinfo',

    GameInfo: {
      NumberOfTaps: 'Anzahl der Tipper:',
      NumberOfGiftsShown: 'Anzahl der Geschenk-Icons:',
      NumberOfGiftsToDrop: 'Anzahl der fallenden Geschenk-Icons:',
      CampaignLifetimeMaxMovesAvailable: 'Gesamte Kampagnenlimits:',
      AccountLifetimeMaxMovesAvailable: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      AccountIntervalMaxMovesAvailable: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      Times: 'mal',
      Per: 'pro'
    },

    CampaignRequestComment: {
      Content: 'Inhalt',
      DeleteButton: 'Löschen-Button',
      Delete: 'Löschen',
      Time: 'Zeit',

      Title: 'Ausstehende Kampagne',

      Description:
        'Diese Kampagne wartet auf Genehmigung. Hinzugefügte Kommentare werden hier angezeigt.',
      CommentsAdded: 'Kommentare hinzugefügt',
      PointsExpiryUnit: 'Punkteverfall (Tage)',
      PointsExpiryPeriod: 'Punkteverfallszeitraum'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Kommentar gelöscht',
      ErrorMessage: 'Fehler beim Löschen des Kommentars',
      Title: 'Kommentar löschen?',
      OkText: 'Löschen',
      DescriptionLineOne: 'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      CancelText: 'Abbrechen'
    },

    ApproveDenyCampaignRequestModalTitle: 'Kampagne genehmigen?',
    ApproveDenyCampaignRequestModalButton: 'Genehmigen',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      ErrorMessage: 'Etwas ist schiefgelaufen',

      ApproveTitle: 'Kampagne genehmigen?',
      Title: 'Löschantrag einreichen?',
      ApproveOkText: 'Genehmigen',
      OkText: 'Löschung beantragen',
      CancelText: 'Abbrechen',

      ApproveDescriptionLineOne: 'Sind Sie sicher, dass Sie diese Kampagne genehmigen möchten?',
      ApproveDescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',

      DescriptionLineOne:
        'Diese Kampagne wartet auf Genehmigung. Sind Sie sicher, dass Sie sie löschen möchten?',
      DescriptionLineTwo:
        'Sobald die Löschung genehmigt ist, wird diese Kampagne nicht mehr verfügbar sein und Sie müssen sie neu erstellen.'
    },

    AddCommentModalTitle: 'Kommentare anzeigen und hinzufügen',
    AddCommentModalButton: 'Kommentar hinzufügen',
    AddCommentModal: {
      SuccessMessage: 'Kommentar hinzugefügt',
      ErrorMessage: 'Fehler beim Hinzufügen des Kommentars',
      CancelText: 'Abbrechen',
      CommentInputPlaceholder: 'Geben Sie hier Ihren Kommentar ein',
      AddCommentButton: 'Kommentar hinzufügen'
    },

    CampaignInfoTitle: 'Kampagnen-Info',

    ReviewInfo: {
      Subtitle: 'Untertitel:',
      Description: 'Beschreibung:',
      TnC: 'AGB:',
      RiskDisclaimer: 'Risikohinweis:',
      BranchName: 'Markenname:',
      Tags: 'Tags:',
      Categories: 'Kategorien:',
      Labels: 'Labels:',
      Catalogue: 'Kataloge:',
      UploadImages: 'Hochgeladene Fotos:',
      Merchant: 'Händler:',
      CustomField: 'Benutzerdefinierte Felder:',
      Type: 'Typ:',
      Url: 'Website-URL:',
      Partner: 'Partner:',
      Reset: 'Zurücksetzen:',
      Stackable: 'Stapelbar:',
      Status: 'Status:',
      Name: 'Kampagnenname:',
      CatalogueName: 'Katalogname:',
      Duration: 'Kampagnendauer:',
      StepsToRedeem: 'Einlöseschritte:',
      ActiveAt: 'Aktiv ab:',
      Owner: 'Besitzer:',
      RewardLegacyAudience: 'Wo kann diese Belohnung angezeigt werden:',
      RewardsCost: 'Belohnungskosten:',
      SellingPrice: 'Verkaufspreis:',

      OperatingDays: 'Betriebstage:',
      OperatingPeriod: 'Betriebszeitraum:',

      ReviewMonth: 'Überprüfungsmonat:',
      PromotionSettings: 'Werbeeinstellungen:',
      DemotionSettings: 'Herabstufungseinstellungen:',
      PromoteUntil: 'Promotion bis:'
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'Social Media URL kopiert!',
      Title: 'Social Media',
      OGTitle: 'Titel',
      OGDescription: 'Beschreibung',
      OGImage: 'Bild',
      OGImageAlt: 'Social Media Vorschau',
      AlternativeIOSLinkDescription: 'iOS App-Link',
      AlternativeAndroidURLDescription: 'Android App-Link',
      OGURL: 'Web-Link',
      SocialMediaURL: 'Social Media URL',
      CopyURLButton: 'URL kopieren',
      OGURLDescription: 'Dieser Link wird erst nach dem Start generiert',
      WebLink: 'Web-Link',
      Description: `Das Feld {{webLink}} muss ausgefüllt sein, damit die Social Media URL generiert werden kann`
    },

    AudienceInfoTitle: 'Zielgruppen-Info',

    AudienceInfo: {
      Description: 'Ausgewählte Zielgruppe:',
      NoListsSelected: 'Keine Listen ausgewählt',
      Include: 'Einschließen',
      Exclude: 'Ausschließen',
      AudienceAttributes: 'Zielgruppenattribute',
      AudienceList: 'Zielgruppenliste'
    },

    EnrolmentSettings: 'Anmeldeeinstellungen',
    AutoEnrolUsers: 'Benutzer automatisch anmelden',
    EnrollableUntil: 'Anmeldbar bis',
    AutoRedeemOutcome: 'Ergebnis automatisch einlösen',
    SendMicrositeNotificationAutoRedeem:
      'Microsite-Benachrichtigung für automatisch eingelöstes Ergebnis senden?',
    StampMechanics: 'Stempel-Mechanik',
    TotalStampCards: 'Gesamtzahl Stempelkarten',
    TotalStampCardsPerUser: 'Stempelkarten pro Benutzer',
    TotalStamps: 'Gesamtzahl Stempel',
    TotalStampsPerUser: 'Stempel pro Benutzer',

    GameMechanics: {
      Title: 'Spielmechanik',
      HitThePinata: {
        Title: 'Triff die Piñata',
        InstructionsLineOne:
          '1. Endbenutzer erhält eine Belohnung basierend auf einer erforderlichen Aktion, in diesem Fall durch das Treffen der Piñata.',
        InstructionsLineTwo:
          '2. Belohnungen werden basierend auf der eingestellten Wahrscheinlichkeit zufällig vergeben',
        IdealFor: 'Ideal für',
        InstructionsLineThree: '1. Saisonales Spiel',
        HeaderMessage: 'Kopfzeilennachricht',
        GameDesign: 'Spieldesign',
        PlayButtonText: 'Spielen-Button-Text'
      },

      ShakeTheTree: {
        Title: 'Schüttel den Baum',
        InstructionsLineOne:
          'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Schütteln des Telefons auffordert',
        GameMechanics: 'Spielmechanik',
        InstructionsLineTwo:
          '1. Endbenutzer erhält eine Belohnung basierend auf einer erforderlichen Aktion, in diesem Fall durch das Schütteln des Telefons',
        InstructionsLineThree:
          '2. Belohnungen werden basierend auf der eingestellten Wahrscheinlichkeit zufällig vergeben',
        IdealFor: 'Ideal für',
        InstructionsLineFour: '1. Saisonales Spiel',
        HeaderMessage: 'Kopfzeilennachricht',
        GameDesign: 'Spieldesign',
        TreeVisual: 'Baum-Visual',
        GiftVisual: 'Geschenk-Visual',
        PlayButtonText: 'Spielen-Button-Text'
      },

      BubblePop: {
        Title: 'Bubble-Pop-Eigenschaften',
        GameTitle: 'Bubble-Pop-Spiel',
        Description: 'Begeistern Sie den Kunden mit seinen Fähigkeiten.',
        BubbleSpawnRate: 'Blasen-Erscheinungsrate',
        GameDuration: 'Spieldauer',
        Seconds: 'Sekunden',
        GameBackground: 'Spielhintergrund',
        NumberOfBubbles: 'Anzahl der Blasen',
        BubbleColors: 'Blasenfarben',
        Bubble: 'Blase',
        CustomImage: 'Benutzerdefiniertes Bild',
        Points: 'Punkte',
        IsBonus: 'ist Bonus?',
        Yes: 'Ja',
        No: 'Nein',
        MaxBubbles: 'max. Blasen',
        SpawnInterval: 'Erscheinungsintervall (in Millisekunden)',
        BubblesPerSpawn: 'Blasen pro Erscheinung',
        BubbleLifetime: 'Blasen-Lebensdauer (in Millisekunden)',
        CustomSpawnRate: 'Benutzerdefinierte Erscheinungsrate'
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Eigenschaften',

        GameMeta: {
          ScratchCard: 'Rubbellos',
          ScratchCardDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Rubbeln einer Spielkarte auffordert.',
          HitThePinata: 'Triff die Piñata',
          HitThePinataDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Schütteln des Telefons auffordert.',
          ShakeTheTree: 'Schüttel den Baum',
          ShakeTheTreeDetails:
            'Binden Sie Kunden mit einer Herausforderung ein, die sie zum Tippen auf das Objekt auffordert.',
          SpinTheWheel: 'Dreh das Glücksrad',
          SpinTheWheelDetails: 'Binden Sie den Kunden mit einem Glücksrad ein.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Lass den Ball fallen und erhalte glückliche Abpraller'
        },

        GameGraphics: {
          AppGraphics: 'App-Grafiken',
          PreScratch: 'Vor dem Rubbeln',
          PostSuccess: 'Nach (Erfolg)',
          PostFail: 'Nach (Misserfolg)',
          RewardIcon: 'Belohnungssymbol',
          NumberOfWedges: 'Anzahl der Segmente',
          WedgeColors: 'Segmentfarben',
          Wedge: 'Segment',
          WheelImage: 'Radbild',
          WheelPosition: 'Radposition',
          PointerImage: 'Zeigerbild',
          Headline: 'Überschrift',
          Subheadline: 'Unterüberschrift',
          AppBackground: 'App-Hintergrund',
          ButtonText: 'Button-Text',

          FrameColor: 'Rahmenfarbe',
          BallColor: 'Ballfarbe',
          HeadlineTextColor: 'Überschrift-Textfarbe',
          SubheadlineTextColour: 'Unterüberschrift-Textfarbe'
        },

        Survey: 'Umfrage',
        SurveyDetails: 'Binden Sie den Kunden mit Multiple-Choice-Fragen ein.',
        Quiz: 'Quiz',
        QuizDetails: 'Binden Sie den Kunden mit Multiple-Choice-Fragen ein.',
        BackgroundImage: 'Hintergrundbild',
        Submit: 'Absenden'
      }
    },

    RewardLimits: {
      Title: 'Belohnungslimits',
      DescriptionLineOne: 'Gesamtzahl der ausgebbaren Belohnungen:',
      DescriptionLineTwo: 'Anzahl der Belohnungen, die jeder Benutzer erhalten kann:',
      DescriptionLineThree: 'Einzelne Benutzer können dieses Spiel nur spielen:',
      DescriptionLineFour: 'Kampagne gibt nur Belohnungen aus:',
      InTotal: 'insgesamt',
      Times: 'mal',
      Per: 'pro'
    },

    Rules: 'Regeln',

    RulePreview: {
      ID: 'ID',
      RulesBalance: 'Regelstand',
      Of: 'von',
      Trigger: 'Auslöser',
      Type: 'Typ',
      Conditions: 'Bedingungen',
      EventName: 'Ereignisname',
      CampaignId: 'Kampagnen-ID',
      RewardId: 'Belohnungs-ID',
      LoyaltyId: 'Treue-ID',
      LoyaltyTierId: 'Treueprogramm-Stufen-ID',
      AutomationTriggerId: 'Automatisierungs-Trigger-ID',
      Outcome: 'Ergebnis',
      NumberOfStamps: 'Anzahl der Stempel',
      AwardPoints: 'Punkte vergeben',
      ForEveryCurrency: 'Für jede Währung',
      UpToAMaximumOfPoints: 'Bis zu einer maximalen Punktzahl von',
      UserEarnsOneRaffleTicket: 'Benutzer erhält 1 Gewinnspiellos',
      TheTaskWillBeMarkedAsDone: 'Die Aufgabe wird als "erledigt" markiert',
      Points: 'Punkte',
      LoyaltyProgram: 'Treueprogramm',
      Award: 'Vergeben',
      GlAccountNumber: 'GL-Kontonummer',
      GlAccountName: 'GL-Kontoname',
      CostCenterId: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      Reward: 'Belohnung',
      Name: 'Name',
      SellingFrom: 'Verkauf ab',
      Limits: 'Limits',
      MaximumEvents: 'Maximale Ereignisse',
      PerCampaign: 'pro Kampagne',
      PerUser: 'pro Benutzer',
      TriggerRateLimit: 'Auslöser-Ratenlimit',
      PerUserForEvery: 'pro Benutzer für jeden',
      SendPushNotificationLabel: 'Push-Benachrichtigung bei jeder Regelauslösung senden?:',
      Attribute: 'Attribut',
      Operator: 'Operator',
      SelectedValues: 'Ausgewählte Werte',
      Conditionals: 'Bedingungen',
      Condition: 'Bedingung',
      NA: 'k.A.',
      PushNotificationRuleForInstantOutcomeTransactionIssue:
        'Push-Benachrichtigungsregel für sofortige Transaktionsausgabe',
      PushNotificationRuleForAutoRedeemInstantOutcomeTriggers:
        'Push-Benachrichtigungsregel für automatisch eingelöste Sofortergebnis-Auslöser',
      CurrencyWithin1: 'Währung innerhalb von 1',
      UserMustPerform: 'Benutzer muss ausführen',
      UserMust: 'Benutzer muss',
      AtLeast: 'mindestens',
      TimesWithin1: 'Mal innerhalb von 1',
      StreakCampaignMechanics: 'Serienkampagnen-Mechanik',
      SendPushNotificationForEveryRuleTrigger:
        'Push-Benachrichtigung für jeden Regel-Auslöser senden?:',
      YES: 'JA',
      NO: 'NEIN',
      MediaTag: 'Medien-Tag:',
      CustomFields: 'Benutzerdefinierte Felder:',
      StreakTarget: 'Serienziel',
      TargetCriteria: 'Zielkriterien',
      StreakPeriod: 'Serienzeitraum',
      Within: 'innerhalb',
      TransactionsWithin: 'Transaktionen innerhalb'
    },
    ActionMechanics: 'Aktionsmechanik',

    InstantRewardMechanics: 'Sofortbelohnungsmechanik',
    InstantRewardMechanicsLabel: 'Kampagne in der Kampagnenliste des Benutzers anzeigen?',
    IssuanceLimits: 'Ausgabelimits',
    IssuanceLimitsLabel: 'Gesamtzahl der Preisausgabe-Ereignisse (auf Kampagnenebene)',
    AccountLifetimeMaxAvailableLabel: 'Gesamtzahl der Preisausgabe-Ereignisse (pro Benutzer)',
    RateLimitCampaignLabel: 'Ratenlimit (auf Kampagnenebene)',
    RateLimitUserLabel: 'Ratenlimit (pro Benutzer)',
    Outcomes: 'Ergebnisse',
    IssuePrizeEvents: 'Preisausgabe-Ereignis(se)',
    LimitTo: 'Limitieren auf',
    ForEvery: 'für jeden',

    PrizeSet: {
      Outcomes: 'Ergebnisse',
      QuizSelectableOne: 'Preise für das Abschließen des Quiz vergeben',
      QuizSelectableTwo: 'Punkte pro richtige Antwort vergeben',
      PointsPerAnswerLabel: 'Punkte pro richtige Antwort:',
      Points: 'Punkte',
      Edit: 'Bearbeiten',
      Remove: 'Entfernen',
      NoPrizeAdded: 'Kein Preis hinzugefügt',
      Prizes: 'Preise',
      AddRandomPrize: 'Zufälligen Preis hinzufügen',
      AddPrizeSet: 'Preisset hinzufügen',
      AddRewards: 'Belohnungen hinzufügen',
      AwardPoints: 'Punkte vergeben',
      AwardBadges: 'Abzeichen vergeben',
      AddPrize: 'Preis hinzufügen',
      IncludeNoPrizeAsOutcome: 'Kein Preis als mögliches Ergebnis einschließen',

      GLACDetail: 'GL-Kontodetail',
      GLACNo: 'GL-Kontonr.',
      GLACName: 'GL-Kontoname',
      GLACType: 'GL-Kontotyp',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',

      WinOdds: 'Gewinnchance',
      Prize: 'Preis',
      Merchant: 'Händler',
      Balance: 'Guthaben',

      GameTry: 'Spielversuch',
      GameTryCampaignSelectWarningText:
        'Nur Kampagnen mit deaktivierter automatischer Ausgabe von Spielversuchen können für die Vergabe von Spielversuchen ausgewählt werden.',
      GameTryCampaignID: 'Spielversuch-Kampagnen-ID: {{campaignId}}',
      NumberofGameTries: 'Anzahl der Spielversuche',
      NoOutcome: 'Kein Ergebnis'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Bitte geben Sie die Anzahl der Punkte pro Antwort an',
      LoyaltyProgramValidationMessage: 'Bitte wählen Sie ein Treueprogramm',
      Title: 'Punkte pro richtige Antwort',
      OkText: 'Speichern',
      CancelText: 'Abbrechen',
      LoyaltyProgramLabel: 'Treueprogramm auswählen',
      LoyaltyProgramSelectPlaceholder: 'Treueprogramm auswählen',
      CountOfPointsLabel: 'Vergeben'
    },

    RewardSelectModal: {
      Title: 'Belohnung auswählen',
      OkText: 'Belohnung hinzufügen',
      CancelText: 'Abbrechen',
      SearchPlaceholder: 'Belohnung nach Name, ID oder Händler suchen',
      ID: 'ID',

      Tabs: {
        All: 'Alle',
        Active: 'Aktiv',
        Approved: 'Genehmigt',
        Private: 'Privat',
        System: 'System'
      },

      Reward: 'Belohnung',
      Merchant: 'Händler',
      Balance: 'Guthaben',
      SellingFrom: 'Verkauf ab',
      SellingTo: 'Verkauf bis'
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Bitte geben Sie die Anzahl der Punkte an',
      LoyaltyProgramValidationMessage: 'Bitte geben Sie ein Treueprogramm an',
      ShowVariablePointsOutcomeValidatioMessage: 'Dieses Feld ist erforderlich',
      GLAccountTypeValidationMessage: 'Bitte wählen Sie einen GL-Kontotyp',
      GLAccountNameValidationMessage: 'Bitte wählen Sie einen GL-Kontonamen',
      GLAccountIDValidationMessage: 'Bitte wählen Sie ein GL-Konto',

      PleaseEnterAGreaterThanZero: 'Bitte geben Sie einen Wert größer als 0 ein.',
      PleaseSpecifyTheNumberOfDays: 'Bitte geben Sie die Anzahl der Tage an.',
      DaysMustBeAtLeastOne: 'Die Anzahl der Tage muss mindestens 1 betragen.',
      AwardedPointsExpireIn: 'Vergebene Punkte verfallen in',
      NumberOfDaysToExpirePlaceholder: 'z.B. 7',
      Days: 'Tage',

      FixedPoints: 'Feste Punkte',
      VariablePoints: 'Variable Punkte',

      IssuePoints: 'Punkte vergeben',
      Save: 'Speichern',
      Cancel: 'Abbrechen',
      SelectLoyaltyProgramLabel: 'Treueprogramm auswählen',
      ShowVariablePointsAlertMessage:
        'Sie können entweder feste oder variable Punkte vergeben. Bei variablen Punkten wird die letzte Transaktion des Benutzers berücksichtigt.',
      NumberOfPointsToAward: 'Zu vergebende Punktzahl',
      NumberOfPointsToAwardPlaceholder: 'z.B. 10',
      SelectGLAccount: 'GL-Konto auswählen',
      SelectGLAccountPlaceholder: 'GL-Konto auswählen',
      GLAccountType: 'GL-Kontotyp',
      GLAccountTypePlaceholder: 'GL-Kontotyp',
      GLAccountName: 'GL-Kontoname',
      GLAccountNamePlaceholder: 'GL-Kontoname',

      AwardedPointsExpire: 'Vergebene Punkte verfallen',
      AfterXDays: 'nach',
      OnCampaignEndDate: 'am Enddatum der Kampagne',
      OnASpecificDate: 'an einem bestimmten Datum',
      CampaignEndDateNotSet: 'Die Kampagne muss ein Enddatum haben, um diese Option zu verwenden.',
      CampaignEndDateRequired:
        "Fehler: Ein Enddatum der Kampagne ist erforderlich. Bitte legen Sie ein Enddatum fest oder deaktivieren Sie die Option 'Am Enddatum der Kampagne'.",
      PointsWillExpireOnEndDate: 'Punkte verfallen am {{date}} am Enddatum der Kampagne.',
      SelectExpiryDateTime: 'Ablaufdatum und -zeit auswählen',
      PleaseSelectExpiryMode: 'Bitte wählen Sie eine Ablaufoption.',
      PleaseSelectAnExpiryDate: 'Bitte wählen Sie ein Ablaufdatum.',
      PleaseSelectAnExpiryTime: 'Bitte wählen Sie eine Ablaufzeit.',
      ExpiryDateMustBeInTheFuture: 'Das Ablaufdatum muss in der Zukunft liegen.',
      AwardedPointsExpireOnCampaignEndDate: 'Vergebene Punkte verfallen am Enddatum der Kampagne',
      AwardedPointsExpireOn: 'Vergebene Punkte verfallen am',
      OnCampaignEndDateSuffix: 'am Enddatum der Kampagne'
    },

    VariablePointsPane: {
      Transaction: 'Transaktion',
      Award: 'Vergeben',
      Every: 'Jede',
      UpToAMaximumAmountOf: 'Bis zu einem Maximalbetrag von'
    },

    BadgeSelectModal: {
      Title: 'Abzeichen zur Anzeige auswählen',
      OkText: 'Abzeichen hinzufügen',
      CancelText: 'Abbrechen'
    },

    BadgeListTable: {
      Name: 'Name',
      StartDate: 'Startdatum',
      EndDate: 'Enddatum',
      Actions: 'Aktionen',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Abzeichen suchen',
      Edit: 'Bearbeiten',
      Deactivate: 'Deaktivieren',
      Activate: 'Aktivieren',
      ErrorSortingBadgeMessage: 'Fehler beim Sortieren des Abzeichens.',
      ErrorUpdatingBadgeStateMessage: 'Fehler beim Aktualisieren des Abzeichenstatus',
      Status: 'Status'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Kein Ergebnis einschließen',
      All: 'Alle',
      Active: 'Aktiv',
      Approved: 'Genehmigt',
      Inactive: 'Inaktiv',
      Ended: 'Beendet',
      Private: 'Privat',
      Points: 'Punkte',
      Custom: 'Benutzerdefiniert'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'GL-Kontonr.',
      GLAccountName: 'GL-Kontoname',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      GLAccountDetail: 'GL-Kontodetail',

      Slot: 'Slot',
      OutcomeType: 'Ergebnistyp',
      AddRewards: 'Belohnungen hinzufügen',
      AwardPoints: 'Punkte vergeben',
      AwardBadges: 'Abzeichen vergeben',
      AddPrizeToSet: 'Preis zum Set hinzufügen',
      IncludeNoPrizeAsOutcome: 'Kein Preis als mögliches Ergebnis einschließen',
      AddAnotherReward: 'Weitere Belohnung hinzufügen',
      AddAnotherBadge: 'Weiteres Abzeichen hinzufügen',
      RewardName: 'Belohnungsname',
      NumberOfPoints: 'Punktzahl',
      ID: 'ID',
      Reward: 'Belohnung',
      Action: 'Aktion',
      Delete: 'Löschen',
      NoOutcome: 'Kein Ergebnis',
      ChangeByAddingReward: 'durch Hinzufügen einer Belohnung ändern',
      AddFixedPrizeSet: 'Festes Preisset hinzufügen',
      AddRandomPrize: 'Zufälligen Preis hinzufügen',
      IssueReward: 'Belohnung vergeben',
      IssuePoints: 'Punkte vergeben',
      IssueBadges: 'Abzeichen vergeben',
      SlotsWithOutcomeAdded: 'Slots mit hinzugefügtem Ergebnis',
      PleaseEnterPrizeTitle: 'Bitte geben Sie Ihren Preistitel ein',
      PrizeTitleRequired: 'Preistitel ist erforderlich'
    },

    OutcomeSettings: {
      Title: 'Ergebniseinstellungen',
      PrizeSet: 'Preisset',
      Submit: 'Absenden',
      MixedRewardsButtonText: 'Button-Text basierend auf der ersten aufgelisteten Belohnung',
      Headline: 'Überschrift'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Quiz-Bildschirme',
      SurveyScreens: 'Umfrage-Bildschirme',
      LandingPage: 'Landingpage',
      LandingScreenHeading: 'Landingpage-Überschrift',
      LandingScreenSubheading: 'Landingpage-Unterüberschrift',
      LandingScreenButtonText: 'Landingpage-Button-Text',
      LandingScreenText: 'Landingpage-Text',
      OutcomeScreen: 'Ergebnis-Bildschirm',
      SuccessfulOutcomeImage: 'Erfolgreiches Ergebnis Bild',
      SuccessfulOutcomeMessage: 'Erfolgreiches Ergebnis Nachricht',
      SuccessfulOutcomeButton: 'Erfolgreiches Ergebnis Button',
      NoOutcomeMessage: 'Kein Ergebnis Nachricht',
      NoOutcomeButton: 'Kein Ergebnis Button',
      NoOutcomeGraphic: 'Grafik ohne Ergebnis',
      OutcomeScreens: 'Ergebnis-Bildschirme',
      WinRewardGraphic: 'Gewinn-Belohnung Grafik',
      WinRewardMessage: 'Gewinn-Belohnung Nachricht',
      WinRewardButton: 'Gewinn-Belohnung Button'
    },

    TeamMechanics: 'Team-Mechanik',
    MemberPerTeam: 'Mitglieder pro Team',
    DisplaySetup: 'Anzeigeeinrichtung',
    LandingPage: 'Landingpage',
    PreEnrolmentMessage: 'Voranmeldungsnachricht',
    StampsEarnMessage: 'Stempel-Sammeln Nachricht',
    JoinTeamPagePreview: {
      Title: 'Einem Team beitreten',
      ButtonText: 'Team beitreten',
      InputPlaceholder: 'Team-Code'
    },
    JoinTeamPage: 'Team-Beitrittsseite',
    JoinTeamInfoMessage: 'Team-Beitritt Infonachricht',
    InviteMemberMessage: 'Mitglied-Einladungsnachricht',
    InviteMemberMessageDescription: 'Mitglied-Einladungsnachricht Beschreibung',
    InviteMemberMessageBlurb: 'Mitglied-Einladungsnachricht Kurztext',

    QuestMechanics: 'Quest-Mechanik',
    UserTriesValidity: 'Gültigkeit der Benutzerversuche',
    Task: 'Aufgabe',
    QuestTask: {
      AddRule: 'Regel hinzufügen',
      Required: '*erforderlich'
    },
    TotalQuests: 'Gesamtzahl der Quests, die in einer Kampagne gestartet werden können',
    TotalQuestsPerUser: 'Gesamtzahl der Quests, die von jedem Benutzer gestartet werden können',
    DisplaySetItup: 'Anzeige einrichten',

    CampaignRuleFormModal: {
      Title: 'Kampagnenregel',
      RuleName: 'Regelname',
      Priority: 'Priorität',
      Outcome: 'Ergebnis',
      Edit: 'Bearbeiten',
      Create: 'Erstellen',
      Update: 'Aktualisieren',
      Add: 'Hinzufügen',
      CancelText: 'Abbrechen',
      RequiredErrorMessage: 'Dieses Feld ist erforderlich.',
      OutcomeRewardRequiredErrorMessage: 'Bitte wählen Sie eine Belohnung',
      OutcomePointsRequiredErrorMessage: 'Bitte wählen Sie ein Treueprogramm',
      GLAccountTypeRequiredErrorMessage: 'Bitte wählen Sie einen GL-Kontotyp',
      GLAccountNameRequiredErrorMessage: 'Bitte wählen Sie einen GL-Kontonamen',
      OutcomeRequiredErrorMessage: 'Dieses Feld ist erforderlich',
      StampsWillBeIssued: 'Stempel werden ausgegeben',
      FixedPoints: 'Feste Punkte',
      VariablePoints: 'Variable Punkte',
      EarnType: 'Ertragstyp',
      Award: 'AWARD',
      Points: 'Punkte',
      ForEvery: 'Für jeden',
      Currency: 'Währung',
      UpToAMaximumOf: 'Bis zu einem Maximalbetrag von',
      QuestOutcomeSegment: 'Die Aufgabe wird als ‘done’ markiert',
      InviteOutcomeSegment: 'Die Aufgabe wird als ‘done’ markiert',
      RaffleOutcomeSegment: 'Der Benutzer erhält einen Gewinnspielschein',
      SelectOutcomeType: 'Ergebnistyp auswählen',
      Reward: 'Belohnung',
      ChangeReward: 'Belohnung ändern',
      SelectReward: 'Belohnung auswählen',
      SelectLoyaltyProgram: 'Treueprogramm auswählen',
      NumberOfPoints: 'Anzahl der Punkte',
      SelectGLAccount: 'GL-Konto auswählen',
      GLAccountType: 'GL-Kontotyp',
      GLAccountTypePlaceholder: 'GL-Kontotyp',
      GLAccountName: 'GL-Kontoname',
      GLAccountNamePlaceholder: 'GL-Kontoname',
      ValidityPeriod: 'Gültigkeitsdauer',

      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Bitte wählen Sie ein Auslöser-Ereignis aus',
        PleaseSelectALoyaltyProgramValue: 'Bitte wählen Sie einen Treueprogrammwert aus',
        PleaseSelectALoyaltyTierValue: 'Bitte wählen Sie eine Treuestufe aus',
        PleaseSelectACampaign: 'Bitte wählen Sie eine Kampagne aus',
        PleaseSelectAStampCampaign: 'Bitte wählen Sie eine Stempel-Kampagne aus',
        PleaseEnterTheNumberOfStamps: 'Bitte geben Sie die Anzahl der Stempel ein',
        NumberOfStampsMustBeAtLeastOne: 'Die Anzahl der Stempel muss mindestens 1 betragen',
        StampPositionMustBeAtLeastOne: 'Die Stempelposition muss mindestens 1 betragen',
        PleaseEnterTheStampPosition: 'Bitte geben Sie die Stempelposition ein',
        PleaseSelectAnAutomationTrigger: 'Bitte wählen Sie einen Automatisierungsauslöser aus',
        IntervalCannotBeLessThanZero: 'Das Intervall darf nicht kleiner als Null sein',
        IntervalCannotBeGreaterThan365: 'Das Intervall darf nicht größer als 365 sein',
        PleaseEnterTheInterval: 'Bitte geben Sie das Intervall ein',
        PleaseSelectAMilestone: 'Bitte wählen Sie einen Meilenstein aus',
        PleaseSelectARule: 'Bitte wählen Sie eine Regel aus',
        PleaseSelectAReward: 'Bitte wählen Sie eine Belohnung aus',
        ThisFieldIsRequired: 'Dieses Feld ist erforderlich',
        TheFieldIsRequired: 'Das Feld ist erforderlich',

        AttributeIsRequired: 'Attribut ist erforderlich',
        OperatorIsRequired: 'Operator ist erforderlich',
        PleaseSelectAtLeastOneDay: 'Bitte wählen Sie mindestens einen Tag aus',
        PleaseSelectATime: 'Bitte wählen Sie eine Uhrzeit aus',
        FromTimeMustBeLessThanToTime: 'Die Startzeit muss vor der Endzeit liegen',
        PleaseSelectAFormTime: 'Bitte wählen Sie eine Startzeit aus',
        PleaseSelectAnToTime: 'Bitte wählen Sie eine Endzeit aus',
        PleaseConfigureTheRuleTriggerDays: 'Bitte konfigurieren Sie die Regel-Auslösetage',

        PleaseConfigureTheTrigger: 'Bitte konfigurieren Sie den Auslöser',
        PleaseFillInTheNameOfTheRule: 'Bitte geben Sie den Namen der Regel ein',
        PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer aus',
        PleaseSelectATriggerRule: 'Bitte wählen Sie eine Auslöseregel aus',
        PleaseSpecifyAStartTime: 'Bitte geben Sie eine Startzeit an',
        PleaseSpecifyAValidEndTime: 'Bitte geben Sie eine gültige Endzeit an',
        PleaseSelectAnOutcomeType: 'Bitte wählen Sie einen Ergebnistyp aus',
        PleaseSelectAMediaTag: 'Bitte wählen Sie ein Medien-Tag aus',
        PleaseSelectAGLAccountType: 'Bitte wählen Sie einen GL-Kontotyp aus',
        PleaseSelectAGLAccountName: 'Bitte wählen Sie einen GL-Kontonamen aus',
        GLAccountIDIsRequired: 'GL-Konto-ID ist erforderlich',
        PleaseEnterAKey: 'Bitte geben Sie einen Schlüssel ein',
        AtLeastOneOutcomePropertyIsRequired:
          'Mindestens eine Ergebnis-Eigenschaft ist erforderlich',
        OutcomePropertiesAreRequired: 'Ergebnis-Eigenschaften sind erforderlich',
        ValueMustBeGreaterThanZero: 'Der Wert muss größer als Null sein.',
        ValueCannotBeZero: 'Der Wert darf nicht Null sein.',
        PleaseEnterANumber: 'Bitte geben Sie eine Zahl ein',
        NumberMustBeAPositiveNumber: 'Die Zahl muss positiv sein',

        OutcomeRequiredErrorMessage: 'Dieses Feld ist erforderlich',
        OutcomePointsRequiredErrorMessage: 'Bitte wählen Sie ein Treueprogramm aus'
      }
    },

    SelectTriggerSection: {
      SelectATrigger: 'Auslöser auswählen',
      Custom: 'Benutzerdefiniert',
      Transaction: 'Transaktion',
      Loyalty: 'Treue',
      Campaign: 'Kampagne',
      Customer: 'Kunde',
      Reward: 'Belohnung',
      Location: 'Standort',
      SelectTrigger: 'Auslöser auswählen',
      SelectATriggerPlaceholder: 'Bitte wählen Sie einen Auslöser',
      Others: 'Benutzerdefiniert',
      LoyaltyTrigger: {
        HelpText: 'Die Anzahl der ablaufenden Punkte wird zu Beginn jedes Prüfzyklus überprüft.',
        AchievedNextTier: 'Nächste Stufe erreicht',
        TenPercentCloseToNextTier: '10% bis zur nächsten Stufe',
        PointsIssued: 'Punkte vergeben',
        AgeingPoints: 'Alternde Punkte (Punkte, die im aktuellen Zyklus ablaufen)',
        SelectLoyaltyProgram: 'Treueprogramm auswählen',
        SelectNextTier: 'Nächste Stufe auswählen',
        SelectNextTierPlaceholder: 'Bitte wählen Sie eine Stufe'
      },
      RewardTrigger: {
        RedeemReward: 'Belohnung einlösen',
        IssueReward: 'Belohnung ausgeben',
        IssueRewardFromCampaign: 'Belohnung aus Kampagne ausgeben',
        IssueRewardFromMerchant: 'Belohnung vom Händler ausgeben',
        VoucherForParticularRewardExpiringIn: 'Gutschein für bestimmte Belohnung läuft ab in',
        AnyVoucherExpiringIn: 'Beliebiger Gutschein läuft ab in {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Stempel eingelöst',
        StampsIssued: 'Stempel ausgegeben',
        StampsInactive: 'Stempel inaktiv',
        GamePlayed: 'Spiel gespielt',
        GameTryIssued: 'Spielversuch ausgegeben',
        CampaignEnrolled: 'An Kampagne teilgenommen',
        CampaignCompleted: 'Kampagne abgeschlossen',
        CampaignNotCompleted: 'Kampagne nicht abgeschlossen',
        ProgressLevelAchieved: 'Fortschrittsstufe erreicht',
        ProgressRuleTriggered: 'Fortschrittsregel ausgelöst',
        QuestTaskCompleted: 'Quest-Aufgabe abgeschlossen',

        SelectAStampCampaign: 'Stempel-Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Stamp: 'Stempel',
        Campaign: 'Kampagne',
        ID: 'ID',
        FooterMsg:
          'Jede {{isCampaignRewardsSelected}} Belohnung in dieser Kampagne wird ein Auslöser',
        SelectStampsSlot: 'Stempel-Slot auswählen',
        StampCardPosition: 'Stempel-Kartenposition'
      },

      CustomerTrigger: {
        SignUp: 'Registrieren',
        SignIn: 'Anmelden',
        ProfileUpdated: 'Profil aktualisiert'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Wählen Sie einen Auslöser...',
        FromDate: 'Von Datum',
        ToDate: 'Bis Datum',
        SelectOperator: 'Operator auswählen',
        PropertyDataType: 'Eigenschaftsdatentyp',
        Key: 'Schlüssel',
        Operator: 'Operator',
        Sunday: 'Sonntag',
        Monday: 'Montag',
        Tuesday: 'Dienstag',
        Wednesday: 'Mittwoch',
        Thursday: 'Donnerstag',
        Friday: 'Freitag',
        Saturday: 'Samstag',
        Value: 'Wert',
        PleaseSeparateMultipleValuesUsingComma: 'Bitte trennen Sie mehrere Werte mit einem Komma',
        SelectTrigger: 'Auslöser auswählen',
        And: 'Und',
        AddCondition: 'Bedingung hinzufügen'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Standortdetails eingeben',
        Latitude: 'Breitengrad',
        Longitude: 'Längengrad',
        LatitudeDegrees: 'Grad ( -90.0 to 90.0 )',
        LongitudeDegrees: 'Grad ( -180.0 to 180.0 )',
        PermissibleRadius: 'Zulässiger Radius (In Meter)',
        Radius: 'Zulässiger Radius',
        Preview: 'VORSCHAU'
      },
      CampaignSelectField: {
        Interval: 'Intervall',
        Days: '(Tage)',
        SelectAStampCampaign: 'Stempel-Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Stamp: 'Stempel',
        SelectACampaign: 'Kampagne auswählen',
        Edit: 'Bearbeiten',
        Add: 'Hinzufügen',
        Campaign: 'Kampagne',
        SelectAMilestone: 'Meilenstein auswählen',
        SelectARule: 'Regel auswählen',
        SelectATask: 'Aufgabe auswählen'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Spiel-Kampagne auswählen',
        Game: 'Spiel',
        Campaign: 'Kampagne',
        Change: 'Ändern',
        Select: 'Auswählen'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Kampagne auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Campaign: 'Kampagne',
        SelectAReward: 'Belohnung auswählen (Optional)',
        Reward: 'Belohnung'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Händler auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Merchant: 'Händler',
        AddMerchant: 'Händler hinzufügen',
        Cancel: 'Abbrechen',
        SearchMerchant: 'Händler nach Name oder ID suchen',
        Active: 'Aktiv',
        Inactive: 'Inaktiv'
      },

      RewardSelectField: {
        SelectAReward: 'Belohnung auswählen (Optional)',
        Change: 'Ändern',
        Reward: 'Belohnung',
        Select: 'Auswählen',
        WarningText:
          'Ergebnistyp ist auf [Push Event] beschränkt, wenn eine System-Belohnung ausgewählt ist'
      },

      RewardExpirySetupField: {
        SelectAReward: 'Belohnung auswählen',
        Change: 'Ändern',
        Select: 'Auswählen',
        Reward: 'Belohnung',
        Periods: 'Zeiträume (Tage)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Auslöserlimits:',
      TotalTriggerEvents: 'Gesamtzahl der Auslöserereignisse (auf Kampagnenebene)',
      TotalTriggerEventsPerUser: 'Gesamtzahl der Auslöserereignisse (pro Benutzer)',
      TriggerRateLimitPerUser: 'Auslöser-Ratenlimit (pro Benutzer)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Lassen Sie die Limit-Felder leer für unbegrenzte Auslöserereignisse -',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      Years: 'Jahre',
      TriggerEventForEvery: 'Auslöserereignis(se) für jeden',
      AccountIntervalLimitPlaceholder: 'z.B. 2',
      AccountIntervalUnitsPlaceholder: 'z.B. 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limitieren auf'
    },

    RuleAudience: {
      SelectFilters: 'Filter auswählen',
      Age: 'Alter',
      Gender: 'Geschlecht',
      Location: 'Standort',
      Language: 'Sprache',
      Device: 'Gerät',
      Browser: 'Browser',
      Customs: 'Benutzerdefiniert',
      Ethnicity: 'Ethnizität',
      Loyalty: 'Treue',
      EmailTags: 'E-Mail-Tags',
      BirthMonth: 'Geburtsmonat',
      NoFiltersSelected: 'Keine Filter ausgewählt',
      SelectedFilters: 'Ausgewählte Filter'
    },

    LoyaltyTier: {
      Includes: 'beinhaltet',
      UsersWhoAchieved: 'Benutzer, die erreicht haben',
      SelectProgramAndTier: 'Programm und Stufe auswählen'
    },

    LevelsAndPrizes: 'Level & Preise',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'Level {{level}} Punkte müssen mehr als Level {{previousLevel}} Punkte sein!',
      LevelTitle: 'Level {{level}} Anzeige',
      TotalCampaignPointsRequired: 'Erforderliche Gesamtkampagnenpunkte für dieses Level:'
    },

    ClaimPrizePopUp: '`Preis beanspruchen` Pop-up',

    LandingPagePreview: {
      CampaignName: 'Kampagnenname',
      Description: 'Beschreibung',
      TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
      PRIZE: 'PREIS',
      PrizeSet: 'Preisset',
      StartPlaying: 'Spielen beginnen'
    },

    EnrolmentPage: 'Anmeldeseite',

    RuleGroupLandingPagePreview: {
      CampaignName: 'Kampagnenname',
      EnrollText: 'ANMELDEN',
      EnrollNow: 'Jetzt anmelden',
      TermsAndConditions: 'Allgemeine Geschäftsbedingungen'
    },

    RaffleReview: {
      DisplaySettings: 'Anzeigeeinstellungen',
      LandingPage: 'Landingpage',
      RaffleTicket: 'Gewinnspiellos',
      GrandPrize: 'Hauptpreis',
      GrandPrizes: 'Hauptpreise'
    },

    DrawSection: {
      RaffleDraw: 'Gewinnspielziehung',
      DownloadCSV: 'CSV herunterladen',
      GenerateRaffleWinners: 'Gewinnspielgewinner generieren',
      SomethingWentWrong: 'Etwas ist schiefgelaufen',
      RaffleCampaignPending:
        'Die Gewinnspielkampagne ist beendet. Klicken Sie auf "Gewinnspielgewinner generieren", um die Gewinnspielziehung auszulösen und automatisch Preise an die Gewinner zu vergeben. Sie können die Liste der Gewinner sehen, sobald die Ziehung abgeschlossen ist.',
      RaffleCampaignSuccess:
        'Die Gewinnspielziehung ist abgeschlossen und die Gewinner haben die Hauptpreise erhalten.'
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Gewinnspielgewinner werden generiert...'
    },

    RaffleWinnersTable: {
      Position: 'Position',
      FirstName: 'Vorname',
      LastName: 'Nachname',
      CustomerID: 'Kunden-ID',
      TicketCode: 'Loscode',
      GrandPrize: 'Hauptpreis',
      PrizeSet: 'Preisset',
      ErrorFetchingWinnersList: 'Fehler beim Abrufen der Gewinnerliste',
      Reversed: 'Storniert'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Gewinnspielcodes konfigurieren',
      CodeGenerationMethod: 'Code-Generierungsmethode',
      TicketCodePrefix: 'Loscode-Präfix',
      LengthOfCode: 'Code-Länge',
      TotalPermutations: 'Gesamtanzahl Permutationen',
      VoucherCodeFormat: 'Gutscheincode-Format',
      VoucherCodeLength: 'Gutscheincode-Länge',
      NumberOfTickets: 'Anzahl der Lose',
      CodeFormat: 'Code-Format'
    },

    RewardAddedTable: {
      Order: 'Reihenfolge',
      Probability: 'Wahrscheinlichkeit',
      Name: 'Name',
      Value: 'Wert',
      Operators: 'Operatoren',
      RuleName: 'Regelname',
      NoOutcome: 'Kein Ergebnis',
      AwardPoints: 'Punkte vergeben',
      Merchant: 'Händler',
      ID: 'ID',
      SellingFrom: 'Verkauf ab',
      SellingTo: 'Verkauf bis',
      RewardBalance: 'Belohnungsstand',
      PointsAwarded: 'Vergebene Punkte',
      ReferrerLimits: 'Empfehlerlimits',
      RefferalsNeeded: 'Benötigte Empfehlungen',
      ReffererRewardLimit: 'Empfehlungsbelohnungslimit',
      RefereeLimits: 'Empfängerlimits',
      GLACNo: 'GL-Kontonummer',
      GLACName: 'GL-Kontoname',
      CostCenterID: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      GLAccountDetail: 'GL-Kontodetails'
    },

    QuizQuestionsReview: {
      Questions: 'Fragen',
      Type: 'Typ',
      TextQuestion: 'Textfrage',
      ImageQuestion: 'Bildfrage',
      WrittenResponse: 'Schreibfrage',
      MultipleAnswers: 'Mehrfachauswahl',
      SingleAnswer: 'Einfachauswahl',
      Question: 'Frage',
      Required: 'Erforderlich',
      Yes: 'Ja',
      No: 'Nein'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Name',
      Status: 'Status',
      Action: 'Aktion',
      Edit: 'Bearbeiten',
      Remove: 'Löschen'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: 'Datei hochgeladen und zur Genehmigung vorgelegt',
      FileUploaded: 'Datei hochgeladen',
      ErrorUploadingFile: 'Fehler beim Hochladen der Datei.',
      Cancel: 'Abbrechen',
      Upload: 'Hochladen',
      BulkUpload: 'Bulk Upload',
      ChooseOne: 'Wählen Sie einen...',
      Campaign: 'Kampagne',
      PleaseSelectACampaign: 'Bitte wählen Sie eine Kampagne',
      LoyaltyProgram: 'Treueprogramm',
      PleaseSelectALoyaltyProgram: 'Bitte wählen Sie ein Treueprogramm',
      ClickOrDragFileToThisAreaToUpload: 'Klicken oder Drag & Drop der Datei in diese Fläche',
      DownloadSample: 'Beispiel herunterladen',
      ActionType: 'Aktionstyp',
      AcceptedFormatXlsxOrCsvFilesOnly: 'Akzeptierte Dateiformat: .xlsx oder .csv Dateien nur',
      AcceptedFormatTxtXlsxOrCsvFilesOnly:
        'Akzeptierte Dateiformat: .txt, .xlsx oder .csv Dateien nur'
    }
  }
};
